/* Mystic shared interaction layer.
   Coordinates app-rendered buttons, wishlist, cart, inline-search service cards, YMQ, and product variant helpers.
   See docs/mystic-js-map.md before extracting code from this file. */

(function () {
  /* Shared selectors, classes, and cross-feature state. */
  var cartCheckoutSelector = '#CartDrawer #checkout.cart-drawer-subtotal__btn.btn--primary';
  var cartCheckoutInteractionAttribute = 'data-mystic-checkout-interactions-enabled';
  var cartCheckoutBoundAttribute = 'data-mystic-checkout-interaction-bound';
  var cartButtonHoverClass = 'mystic-cart-button--hover';
  var cartButtonActiveClass = 'mystic-cart-button--active';
  var signupButtonSelector =
    'form[id^="PopupSignupForm-"] .popup__btn[data-submit-btn], form[id^="PopupSignupForm-"] .popup__btn[data-close-btn], form[id^="PopupSignupForm-"] .popup__btn-link';
  var signupButtonBoundAttribute = 'data-mystic-signup-interaction-bound';
  var signupPointerMoveBoundAttribute = 'data-mystic-signup-pointer-move-bound';
  var signupButtonHoverClass = 'mystic-signup-button--hover';
  var signupButtonActiveClass = 'mystic-signup-button--active';
  var searchServiceButtonSelector =
    '.predictive-search-services-section .horizontal-product-card__button.btn, .predictive-search-services-section .horizontal-product-card button';
  var searchServiceCardSelector =
    '.predictive-search-services-section .horizontal-product-card';
  var searchServiceButtonBoundAttribute = 'data-mystic-search-service-button-bound';
  var searchServiceCardBoundAttribute = 'data-mystic-search-service-card-bound';
  var searchServicePointerBoundAttribute = 'data-mystic-search-service-pointer-bound';
  var searchServiceButtonHoverClass = 'mystic-search-service-button--hover';
  var searchServiceButtonActiveClass = 'mystic-search-service-button--active';
  var searchCardTouchSelector =
    '.predictive-result-card, .predictive-search-services-section .horizontal-product-card';
  var searchCardTouchClass = 'mystic-inline-search-card--touch';
  var searchCardTouchAttribute = 'data-mystic-inline-search-card-touch-bound';
  var variantOptionSelector =
    'variant-picker.product-variant-picker .pill, variant-picker.product-variant-picker .image-swatches__item, variant-picker.product-variant-picker .color-swatch-select-parent';
  var variantOptionGroupSelector =
    '.product-variant-picker__pill-list, .product-variant-picker__image-swatches, .product-variant-picker__shape-swatches';
  var variantSelectedOptionSelector =
    '.pill.selected, .image-swatches__item.selected, .color-swatch-select-parent.selected';
  var variantBorderBoundAttribute = 'data-mystic-variant-border-bound';
  var variantPointerBoundAttribute = 'data-mystic-variant-pointer-bound';
  var variantActiveValueBoundAttribute = 'data-mystic-variant-active-value-bound';
  var variantSyncBoundAttribute = 'data-mystic-variant-sync-bound';
  var variantResizeBoundAttribute = 'data-mystic-variant-resize-bound';
  var variantSyncedEventName = 'aurora:variant-picker-synced';
  var variantIndicatorClass = 'mystic-variant-selection-indicator';
  var variantIndicatorReadyClass = 'mystic-variant-indicator-ready';
  var variantPreferredTargets = new WeakMap();
  var wishlistSelectSelector = '.wl-card__variant-select, .wl-page__bulk-select, .wl-list-select';
  var wishlistSelectEnhancedAttribute = 'data-mystic-wishlist-select-enhanced';
  var wishlistSelectWrapperClass = 'mystic-wishlist-select';
  var wishlistSelectOpenClass = 'mystic-wishlist-select--open';
  var wishlistSelectMenuClass = 'mystic-wishlist-select-menu';
  var wishlistSelectButtonClass = 'mystic-wishlist-select__button';
  var wishlistSelectLabelClass = 'mystic-wishlist-select__label';
  var wishlistSelectOptionClass = 'mystic-wishlist-select-menu__option';
  var wishlistVariantSelectClass = 'mystic-wishlist-select--variant';
  var wishlistVariantViewRowClass = 'mystic-wishlist-variant-view-row';
  var wishlistVariantViewButtonClass = 'mystic-wishlist-variant-view';
  var wishlistBulkRootSelector = '.wl-page__container, .wl-popup, .wl-drawer';
  var wishlistBulkSelectedClass = 'mystic-wishlist-bulk-has-selected';
  var wishlistPopupEnhancedAttribute = 'data-mystic-wishlist-popup-enhanced';
  var wishlistPopupHandleAttribute = 'data-mystic-wishlist-popup-handle';
  var wishlistPopupDraggingClass = 'mystic-wishlist-popup-dragging';
  var wishlistPopupSurfaceClass = 'mystic-wishlist-popup-sheet-surface';
  var wishlistPopupClosingGhostClass = 'mystic-wishlist-popup-closing-ghost';
  var wishlistModalClosingGhostClass = 'mystic-wishlist-modal-closing-ghost';
  var wishlistPopupPrivateClass = 'mystic-wishlist-popup--private';
  var wishlistPopupPublicClass = 'mystic-wishlist-popup--public';
  var wishlistMoveDropdownEnhancedAttribute = 'data-mystic-wishlist-move-dropdown-enhanced';
  var wishlistMoveDropdownHiddenClass = 'mystic-wishlist-move-list--native-hidden';
  var judgeMeSortSelectSelector = '#judgeme_product_reviews .jm-sort-filter__select, #judgeme_product_reviews .jdgm-sort-dropdown';
  var judgeMeSortEnhancedAttribute = 'data-mystic-judgeme-sort-enhanced';
  var judgeMeSortWrapperClass = 'mystic-judgeme-sort';
  var judgeMeSortOpenClass = 'mystic-judgeme-sort--open';
  var judgeMeSortButtonClass = 'mystic-judgeme-sort__button';
  var judgeMeSortLabelClass = 'mystic-judgeme-sort__label';
  var judgeMeSortMenuClass = 'mystic-judgeme-sort__menu';
  var judgeMeSortOptionClass = 'mystic-judgeme-sort__option';
  var wishlistProductDataCache = {};
  var wishlistSearchIconEnhancedAttribute = 'data-mystic-search-icon-style-5';
  var wishlistSearchIconSvg =
    '<svg class="mystic-wishlist-search-icon-style-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 26" fill="none" aria-hidden="true"><path d="M21 21.8864L17.5096 18.3963M17.5096 18.3963C19.0471 16.8581 19.998 14.7335 19.998 12.3867C19.998 7.6923 16.1929 3.88672 11.499 3.88672C6.80514 3.88672 3 7.6923 3 12.3867C3 17.0811 6.80514 20.8867 11.499 20.8867C13.8464 20.8867 15.9715 19.935 17.5096 18.3963Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var wishlistPageRemoveSelector = '.wl-page__container .wl-card__remove, .wl-popup .wl-card__remove, .wl-drawer .wl-card__remove';
  var wishlistDrawerTrendingSelector = '.wl-drawer.wl-drawer--open .wl-popup__trending, .wl-drawer.wl-drawer--open .wl-trending';
  var wishlistDrawerTrendingPageAttribute = 'data-mystic-drawer-carousel-page';
  var wishlistDrawerTrendingBoundAttribute = 'data-mystic-drawer-carousel-bound';
  var wishlistDrawerTrendingObserverAttribute = 'data-mystic-drawer-carousel-observer-bound';
  var wishlistDrawerTrendingNormalizingAttribute = 'data-mystic-drawer-carousel-normalizing';
  var wishlistDrawerTrendingCardsPerPage = 4;
  var wishlistRemoveConfirmedAttribute = 'data-mystic-wishlist-remove-confirmed';
  var wishlistRemoveConfirmOverlayClass = 'mystic-wishlist-remove-confirm';
  var wishlistRemoveConfirmOpenClass = 'mystic-wishlist-remove-confirm--open';
  var wishlistRemoveAllModalClass = 'mystic-wishlist-remove-all-modal';
  var wishlistDestructiveModalClass = 'mystic-wishlist-destructive-modal';
  var wishlistAddCartConfirmClass = 'mystic-wishlist-add-cart-confirm';
  var wishlistRegistryPlaceholderText = 'Public Wishlists & Registries';
  var wishlistPrivateTabText = 'Private Wishlists';
  var wishlistPublicTabText = 'Public Wishlists';
  var wishlistServiceButtonSelector = '.wl-card__add-cart[data-wl-product-handle]';
  var wishlistServiceChoiceAttribute = 'data-mystic-service-choice';
  var wishlistServiceUrlAttribute = 'data-mystic-service-url';
  var wishlistServiceHandleMap = null;
  var wishlistEnhancementTimer = null;
  var wishlistEnhancementFrame = null;
  var wishlistEnhancementRunning = false;
  var globalEnhancementFrame = null;
  var pendingWishlistRemoveButton = null;
  var wishlistPopupPointerStartY = null;
  var wishlistPopupPointerStartX = null;
  var wishlistPopupPointerId = null;
  var wishlistPopupPointerActive = false;
  var wishlistPopupPointerPopup = null;
  var wishlistPopupMouseActive = false;

  /* Wishlist remove confirmation modal. */
  function getWishlistRemoveProductTitle(button) {
    var card = button && button.closest('.wl-card');
    var title = card && card.querySelector('.wl-card__title');

    return title ? title.textContent.trim() : '';
  }

  function closeWishlistRemoveConfirm() {
    var overlay = document.querySelector('.' + wishlistRemoveConfirmOverlayClass);

    pendingWishlistRemoveButton = null;

    if (overlay) {
      overlay.classList.remove(wishlistRemoveConfirmOpenClass);
      overlay.setAttribute('aria-hidden', 'true');
    }
  }

  function confirmWishlistRemove() {
    var button = pendingWishlistRemoveButton;
    var clickEvent;

    closeWishlistRemoveConfirm();

    if (!button || !document.documentElement.contains(button)) {
      return;
    }

    button.setAttribute(wishlistRemoveConfirmedAttribute, 'true');
    clickEvent = document.createEvent('MouseEvents');
    clickEvent.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
    button.dispatchEvent(clickEvent);
    button.removeAttribute(wishlistRemoveConfirmedAttribute);
  }

  function ensureWishlistRemoveConfirm() {
    var overlay = document.querySelector('.' + wishlistRemoveConfirmOverlayClass);
    var panel;
    var message;
    var cancelButton;
    var confirmButton;

    if (overlay) {
      return overlay;
    }

    overlay = document.createElement('div');
    overlay.className = wishlistRemoveConfirmOverlayClass;
    overlay.setAttribute('aria-hidden', 'true');

    panel = document.createElement('div');
    panel.className = 'mystic-wishlist-remove-confirm__panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-labelledby', 'mystic-wishlist-remove-confirm-title');
    panel.setAttribute('aria-describedby', 'mystic-wishlist-remove-confirm-message');

    panel.innerHTML =
      '<h2 id="mystic-wishlist-remove-confirm-title" class="mystic-wishlist-remove-confirm__title">Remove this item?</h2>' +
      '<p id="mystic-wishlist-remove-confirm-message" class="mystic-wishlist-remove-confirm__message">Are you sure you want to delete this item from your wishlist?</p>' +
      '<div class="mystic-wishlist-remove-confirm__actions">' +
      '<button type="button" class="mystic-wishlist-remove-confirm__button mystic-wishlist-remove-confirm__button--secondary" data-mystic-wishlist-remove-cancel>No</button>' +
      '<button type="button" class="mystic-wishlist-remove-confirm__button mystic-wishlist-remove-confirm__button--primary" data-mystic-wishlist-remove-confirm>Yes, Remove</button>' +
      '</div>';

    overlay.appendChild(panel);
    document.body.appendChild(overlay);

    message = panel.querySelector('.mystic-wishlist-remove-confirm__message');
    cancelButton = panel.querySelector('[data-mystic-wishlist-remove-cancel]');
    confirmButton = panel.querySelector('[data-mystic-wishlist-remove-confirm]');

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
        closeWishlistRemoveConfirm();
      }
    });

    cancelButton.addEventListener('click', closeWishlistRemoveConfirm);
    confirmButton.addEventListener('click', confirmWishlistRemove);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && overlay.classList.contains(wishlistRemoveConfirmOpenClass)) {
        closeWishlistRemoveConfirm();
      }
    });

    overlay.updateMessage = function (productTitle) {
      message.textContent = productTitle
        ? 'Are you sure you want to delete "' + productTitle + '" from your wishlist?'
        : 'Are you sure you want to delete this item from your wishlist?';
    };

    return overlay;
  }

  function openWishlistRemoveConfirm(button) {
    var overlay = ensureWishlistRemoveConfirm();

    pendingWishlistRemoveButton = button;
    overlay.updateMessage(getWishlistRemoveProductTitle(button));
    overlay.classList.add(wishlistRemoveConfirmOpenClass);
    overlay.setAttribute('aria-hidden', 'false');

    window.setTimeout(function () {
      var cancelButton = overlay.querySelector('[data-mystic-wishlist-remove-cancel]');

      if (cancelButton) {
        cancelButton.focus({ preventScroll: true });
      }
    }, 30);
  }

  function isWishlistPopupSheetView() {
    return window.matchMedia && window.matchMedia('(max-width: 1023px)').matches;
  }

  function clearWishlistPopupDragState() {
    if (wishlistPopupPointerPopup) {
      wishlistPopupPointerPopup.classList.remove(wishlistPopupDraggingClass);
      wishlistPopupPointerPopup.style.removeProperty('--mystic-wishlist-popup-drag-y');
    }

    wishlistPopupPointerStartY = null;
    wishlistPopupPointerStartX = null;
    wishlistPopupPointerId = null;
    wishlistPopupPointerActive = false;
    wishlistPopupPointerPopup = null;
    wishlistPopupMouseActive = false;
  }

  function closeWishlistPopupSheet(popup) {
    var closeButton = popup && popup.querySelector('.wl-popup__close');

    createWishlistPopupClosingGhost(popup);

    if (closeButton && typeof closeButton.click === 'function') {
      closeButton.click();
    }
  }

  function createWishlistPopupClosingGhost(popup) {
    var rect;
    var clone;

    if (!popup || !isWishlistPopupSheetView() || !popup.classList.contains('wl-popup--open')) {
      return;
    }

    rect = popup.getBoundingClientRect();

    if (rect.width < 1 || rect.height < 1 || rect.bottom <= 0 || rect.top >= window.innerHeight) {
      return;
    }

    document.querySelectorAll('.' + wishlistPopupClosingGhostClass).forEach(function (existingGhost) {
      existingGhost.remove();
    });

    clone = popup.cloneNode(true);
    clone.classList.add(wishlistPopupClosingGhostClass);
    clone.classList.remove(wishlistPopupDraggingClass);
    clone.removeAttribute('id');
    clone.setAttribute('aria-hidden', 'true');
    clone.style.position = 'fixed';
    clone.style.left = rect.left + 'px';
    clone.style.top = rect.top + 'px';
    clone.style.width = rect.width + 'px';
    clone.style.height = rect.height + 'px';
    clone.style.margin = '0';
    clone.style.zIndex = '1000036';
    clone.style.pointerEvents = 'none';
    clone.style.setProperty('transform', 'translateY(0)', 'important');
    clone.style.setProperty('transition', 'transform 280ms cubic-bezier(0.22, 1, 0.36, 1)', 'important');
    clone.style.setProperty('--mystic-wishlist-popup-drag-y', '0px');

    document.body.appendChild(clone);
    clone.getBoundingClientRect();

    window.setTimeout(function () {
      clone.style.setProperty('transform', 'translateY(110%)', 'important');
    }, 20);

    window.setTimeout(function () {
      clone.remove();
    }, 340);
  }

  function createWishlistModalClosingGhost(modalBackdrop) {
    var rect;
    var clone;

    if (!modalBackdrop || !modalBackdrop.classList || !modalBackdrop.classList.contains('wl-modal-backdrop')) {
      return;
    }

    rect = modalBackdrop.getBoundingClientRect();

    if (rect.width < 1 || rect.height < 1) {
      return;
    }

    document.querySelectorAll('.' + wishlistModalClosingGhostClass).forEach(function (existingGhost) {
      existingGhost.remove();
    });

    clone = modalBackdrop.cloneNode(true);
    clone.classList.add(wishlistModalClosingGhostClass);
    clone.setAttribute('aria-hidden', 'true');
    clone.style.position = 'fixed';
    clone.style.left = rect.left + 'px';
    clone.style.top = rect.top + 'px';
    clone.style.width = rect.width + 'px';
    clone.style.height = rect.height + 'px';
    clone.style.margin = '0';
    clone.style.zIndex = '1000026';
    clone.style.pointerEvents = 'none';
    clone.style.setProperty('opacity', '1', 'important');
    clone.style.setProperty('transition', 'opacity 180ms ease', 'important');

    document.body.appendChild(clone);
    clone.getBoundingClientRect();

    window.setTimeout(function () {
      clone.style.setProperty('opacity', '0', 'important');
    }, 20);

    window.setTimeout(function () {
      clone.remove();
    }, 240);
  }

  function startWishlistPopupDrag(popup, clientX, clientY, pointerId) {
    wishlistPopupPointerStartY = clientY;
    wishlistPopupPointerStartX = clientX;
    wishlistPopupPointerId = pointerId;
    wishlistPopupPointerActive = true;
    wishlistPopupPointerPopup = popup;
  }

  function getWishlistPopupDragTrigger(target) {
    if (!target || !target.closest) {
      return null;
    }

    if (target.closest('.wl-popup__close')) {
      return null;
    }

    return target.closest('[' + wishlistPopupHandleAttribute + '], .wl-popup__header');
  }

  function hasActiveWishlistChildModal() {
    return !!document.querySelector(
      '.wl-modal, .wl-modal-backdrop, .wl-list-modal, .wl-list-modal-backdrop, .wl-confirm, .wl-confirm-backdrop'
    );
  }

  function holdWishlistPopupBodyHeight(element) {
    var popup = element && element.closest && element.closest('.wl-popup');
    var body = popup && popup.querySelector('.wl-popup__body');
    var rect;

    if (!body) {
      return;
    }

    rect = body.getBoundingClientRect();

    if (rect.height < 1) {
      return;
    }

    body.style.minHeight = Math.round(rect.height) + 'px';

    window.setTimeout(function () {
      body.style.removeProperty('min-height');
    }, 720);
  }

  function moveWishlistPopupDrag(clientX, clientY, pointerId) {
    var deltaY;
    var deltaX;

    if (!wishlistPopupPointerActive || !wishlistPopupPointerPopup || pointerId !== wishlistPopupPointerId) {
      return;
    }

    deltaY = clientY - wishlistPopupPointerStartY;
    deltaX = Math.abs(clientX - wishlistPopupPointerStartX);

    if (deltaY <= 0 || deltaX > Math.max(36, deltaY * 1.2)) {
      return;
    }

    wishlistPopupPointerPopup.classList.add(wishlistPopupDraggingClass);
    wishlistPopupPointerPopup.style.setProperty('--mystic-wishlist-popup-drag-y', Math.min(deltaY, 180) + 'px');
  }

  function endWishlistPopupDrag(clientX, clientY, pointerId) {
    var popup;
    var deltaY;
    var deltaX;

    if (!wishlistPopupPointerActive || !wishlistPopupPointerPopup || pointerId !== wishlistPopupPointerId) {
      return;
    }

    popup = wishlistPopupPointerPopup;
    deltaY = clientY - wishlistPopupPointerStartY;
    deltaX = Math.abs(clientX - wishlistPopupPointerStartX);

    if (deltaY > 72 && deltaY > deltaX * 1.2) {
      popup.classList.remove(wishlistPopupDraggingClass);
      closeWishlistPopupSheet(popup);

      window.setTimeout(function () {
        popup.style.removeProperty('--mystic-wishlist-popup-drag-y');
      }, 280);

      wishlistPopupPointerStartY = null;
      wishlistPopupPointerStartX = null;
      wishlistPopupPointerId = null;
      wishlistPopupPointerActive = false;
      wishlistPopupPointerPopup = null;
      wishlistPopupMouseActive = false;
      return;
    }

    clearWishlistPopupDragState();
  }

  function enhanceWishlistPopupSheets() {
    document.querySelectorAll('.wl-popup').forEach(function (popup) {
      var surface;
      var handle;

      syncWishlistPopupTabState(popup);

      if (popup.getAttribute(wishlistPopupEnhancedAttribute) === 'true') {
        return;
      }

      surface = popup;
      surface.classList.add(wishlistPopupSurfaceClass);

      handle = document.createElement('button');
      handle.type = 'button';
      handle.className = 'mystic-wishlist-popup-handle';
      handle.setAttribute(wishlistPopupHandleAttribute, 'true');
      handle.setAttribute('aria-label', 'Drag down to close wishlist');
      handle.innerHTML = '<span class="mystic-wishlist-popup-handle__bar" aria-hidden="true"></span>';

      surface.insertBefore(handle, surface.firstChild);
      popup.setAttribute(wishlistPopupEnhancedAttribute, 'true');

      popup.addEventListener('click', function (event) {
        var tab = event.target && event.target.closest && event.target.closest('[data-wl-popup-tab]');
        var targetMode;

        if (!tab || !popup.contains(tab)) {
          return;
        }

        targetMode = tab.getAttribute('data-wl-popup-tab');
        syncWishlistPopupTabState(popup, targetMode);

        [80, 220, 520, 900].forEach(function (delay) {
          window.setTimeout(function () {
            syncWishlistPopupTabState(popup);
            if (delay >= 520) {
              ensureWishlistPopupTabContent(popup, targetMode);
            }
          }, delay);
        });
      }, true);
    });
  }

  function syncWishlistPopupTabState(popup, preferredMode) {
    var activeTab;
    var mode = preferredMode;

    if (!popup) {
      return;
    }

    if (!mode) {
      activeTab = popup.querySelector('[data-wl-popup-tab].wl-page-tab--active');
      mode = activeTab && activeTab.getAttribute('data-wl-popup-tab');
    }

    if (mode !== 'public' && mode !== 'private') {
      mode = 'private';
    }

    popup.classList.toggle(wishlistPopupPublicClass, mode === 'public');
    popup.classList.toggle(wishlistPopupPrivateClass, mode !== 'public');
  }

  function hasVisibleWishlistPopupElement(popup, selector) {
    return !!Array.prototype.find.call(popup.querySelectorAll(selector), function (element) {
      var rect = element.getBoundingClientRect();

      return rect.width > 0 && rect.height > 0;
    });
  }

  function ensureWishlistPopupTabContent(popup, mode, attempt) {
    var retryAttempt = attempt || 0;
    var tab;
    var hasPublicContent;
    var hasPrivateContent;

    if (!popup || retryAttempt > 2) {
      return;
    }

    hasPublicContent = hasVisibleWishlistPopupElement(popup, '.wl-pub-search-wrap, .wl-pub-search-result, .wl-pub-empty');
    hasPrivateContent = hasVisibleWishlistPopupElement(popup, '.wl-grid, .wl-popup__top-bar');

    if (mode === 'public' && !hasPublicContent && hasPrivateContent) {
      tab = popup.querySelector('[data-wl-popup-tab="public"]');
    }

    if (mode === 'private' && !hasPrivateContent && hasPublicContent) {
      tab = popup.querySelector('[data-wl-popup-tab="private"]');
    }

    if (!tab || typeof tab.click !== 'function') {
      return;
    }

    tab.click();

    window.setTimeout(function () {
      ensureWishlistPopupTabContent(popup, mode, retryAttempt + 1);
    }, 360);
  }

  /* Chizy product button copy and interaction state. */
  function updateChizyCartButtonLabels() {
    document
      .querySelectorAll('#chizy-chat-root .chizy-product-btn-primary, #chizy-chat-root .chizy-product-btn-primary-v2')
      .forEach(function (button) {
        if (button.getAttribute('data-mystic-chizy-button-bound') !== 'true') {
          button.setAttribute('data-mystic-chizy-button-bound', 'true');

          button.addEventListener('mouseenter', function () {
            button.classList.add('mystic-chizy-product-btn--hover');
          });

          button.addEventListener('mouseleave', function () {
            button.classList.remove('mystic-chizy-product-btn--hover');
          });

          button.addEventListener('blur', function () {
            button.classList.remove('mystic-chizy-product-btn--hover');
          });
        }

        Array.prototype.forEach.call(button.childNodes, function (node) {
          if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim().toLowerCase() === 'add to cart') {
            node.nodeValue = 'Add To Bag';
          }
        });
      });
  }

  /* Wishlist services: switch Add To Bag to Choose Options and route to selected variant. */
  function getWishlistServiceHandleMap() {
    var script;
    var handles;

    if (wishlistServiceHandleMap) {
      return wishlistServiceHandleMap;
    }

    wishlistServiceHandleMap = {};
    script = document.getElementById('MysticServicesProductHandles');

    if (!script || !script.textContent) {
      return wishlistServiceHandleMap;
    }

    try {
      handles = JSON.parse(script.textContent);
    } catch (error) {
      handles = [];
    }

    if (!Array.isArray(handles)) {
      return wishlistServiceHandleMap;
    }

    handles.forEach(function (handle) {
      if (handle) {
        wishlistServiceHandleMap[String(handle)] = true;
      }
    });

    return wishlistServiceHandleMap;
  }

  function getWishlistCardProductUrl(element) {
    var card = element && element.closest('.wl-card');
    var link = card && card.querySelector('a[href*="/products/"]');
    var handleSource = card && card.querySelector('[data-wl-product-handle]');
    var handle = (element && element.getAttribute('data-wl-product-handle')) || (handleSource && handleSource.getAttribute('data-wl-product-handle'));
    var variantSelect = card && card.querySelector('.wl-card__variant-select');
    var variantId = variantSelect?.value || element?.getAttribute('data-variant-id') || '';
    var url = '';

    if (link) {
      url = link.getAttribute('href') || '';
    } else if (handle) {
      url = '/products/' + handle;
    }

    if (url && variantId) {
      url = url
        .replace(/([?&])variant=[^&#]*&?/, '$1')
        .replace(/[?&]$/, '');
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(variantId);
    }

    return url;
  }

  function updateWishlistCardImageLink(element) {
    var card = element && element.closest('.wl-card');
    var imageLink = card && card.querySelector('.wl-card__img-wrap[href*="/products/"]');
    var url = imageLink && getWishlistCardProductUrl(imageLink);

    if (imageLink && url) {
      imageLink.href = url;
    }
  }

  function getWishlistProductHandle(card) {
    var handleSource = card && card.querySelector('[data-wl-product-handle]');
    var imageLink = card && card.querySelector('.wl-card__img-wrap[href*="/products/"]');
    var href = imageLink && imageLink.getAttribute('href');
    var match;

    if (handleSource && handleSource.getAttribute('data-wl-product-handle')) {
      return handleSource.getAttribute('data-wl-product-handle');
    }

    match = href && href.match(/\/products\/([^?#/]+)/);
    return match ? match[1] : '';
  }

  function getWishlistProductData(handle) {
    if (!handle) {
      return Promise.resolve(null);
    }

    if (!wishlistProductDataCache[handle]) {
      wishlistProductDataCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin'
      })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .catch(function () {
          return null;
        });
    }

    return wishlistProductDataCache[handle];
  }

  function getWishlistVariantImageSrc(variant) {
    if (!variant) {
      return '';
    }

    if (variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }

    if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
      return variant.featured_media.preview_image.src;
    }

    return '';
  }

  function normalizeWishlistImageSrc(src) {
    return src ? String(src).replace(/^https?:/, '') : '';
  }

  function updateWishlistCardVariantImage(element) {
    var card = element && element.closest('.wl-card');
    var select = card && card.querySelector('.wl-card__variant-select');
    var image = card && card.querySelector('.wl-card__img');
    var handle = getWishlistProductHandle(card);
    var variantId = select && select.value;

    if (!card || !select || !image || !handle || !variantId) {
      return;
    }

    card.setAttribute('data-mystic-wishlist-image-variant', variantId);

    getWishlistProductData(handle).then(function (product) {
      var variant;
      var imageSrc;

      if (!product || card.getAttribute('data-mystic-wishlist-image-variant') !== variantId) {
        return;
      }

      variant = Array.isArray(product.variants)
        ? product.variants.find(function (item) {
          return String(item.id) === String(variantId);
        })
        : null;

      imageSrc = getWishlistVariantImageSrc(variant);

      if (
        !imageSrc ||
        normalizeWishlistImageSrc(image.currentSrc || image.getAttribute('src')) === normalizeWishlistImageSrc(imageSrc)
      ) {
        return;
      }

      var pendingImage = new Image();
      pendingImage.onload = function () {
        if (card.getAttribute('data-mystic-wishlist-image-variant') !== variantId) {
          return;
        }

        image.removeAttribute('srcset');
        image.src = imageSrc;
      };
      pendingImage.src = imageSrc;
    });
  }

  function preloadWishlistCardProductData() {
    document.querySelectorAll('.wl-card').forEach(function (card) {
      var handle = getWishlistProductHandle(card);

      if (handle) {
        getWishlistProductData(handle);
      }
    });
  }

  function setWishlistServiceButtonLabel(button, url) {
    if (
      button.getAttribute(wishlistServiceChoiceAttribute) === 'true'
      && button.getAttribute(wishlistServiceUrlAttribute) === url
      && button.textContent.trim() === 'Choose Options'
    ) {
      return;
    }

    button.setAttribute(wishlistServiceChoiceAttribute, 'true');
    button.setAttribute(wishlistServiceUrlAttribute, url);
    button.setAttribute('aria-label', 'Choose Options');

    if (button.textContent.trim() !== 'Choose Options') {
      button.textContent = 'Choose Options';
    }
  }

  function updateWishlistServiceButtons() {
    var serviceHandles = getWishlistServiceHandleMap();

    document.querySelectorAll(wishlistServiceButtonSelector).forEach(function (button) {
      var handle = button.getAttribute('data-wl-product-handle');
      var url;

      if (!handle || !serviceHandles[handle]) {
        return;
      }

      url = getWishlistCardProductUrl(button);

      if (!url) {
        return;
      }

      setWishlistServiceButtonLabel(button, url);
    });
  }

  /* Wishlist modal detection for Remove All / Empty Wishlist styling. */
  function markWishlistRemoveAllModals() {
    document.querySelectorAll('.wl-modal').forEach(function (modal) {
      var text = (modal.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      var isRemoveAllModal = text.indexOf('remove all') !== -1 || text.indexOf('empty wishlist') !== -1;
      var isDestructiveModal =
        isRemoveAllModal ||
        text.indexOf('delete') !== -1 ||
        text.indexOf('remove selected') !== -1 ||
        text.indexOf('remove from wishlist') !== -1;

      modal.classList.toggle(wishlistRemoveAllModalClass, isRemoveAllModal);
      modal.classList.toggle(wishlistDestructiveModalClass, isDestructiveModal);
    });
  }

  /* Wishlist Add To Bag keep/remove popover. */
  function markWishlistAddCartConfirms() {
    document.querySelectorAll('.wl-confirm, [class*="popover"], [class*="tooltip"], [class*="confirm"]').forEach(function (confirm) {
      var text = (confirm.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      var isAddCartConfirm =
        text.indexOf('add to cart') !== -1 &&
        text.indexOf('remove this item from your wishlist') !== -1 &&
        text.indexOf('keep') !== -1 &&
        text.indexOf('remove') !== -1;

      confirm.classList.toggle(wishlistAddCartConfirmClass, isAddCartConfirm);
    });
  }

  /* YMQ price disclaimer helpers. Intentionally no-op where native app text must stay intact. */
  function formatYmqPriceDisclaimers() {
    return;
  }

  function restoreYmqNativePriceDisclaimers() {
    document.querySelectorAll('#ymqmodal-edit-option .ymq-option-addon, .ymq_modal__container .ymq-option-addon').forEach(function (addon) {
      var formattedPrice;

      if (!addon) {
        return;
      }

      addon.removeAttribute('data-mystic-ymq-price-formatted');

      formattedPrice = addon.querySelector('.mystic-ymq-addon-price');

      if (formattedPrice) {
        formattedPrice.replaceWith(document.createTextNode(formattedPrice.textContent || ''));
      }
    });
  }

  function formatYmqProductPriceDisclaimers() {
    return;
  }

  function runWishlistEnhancements() {
    if (wishlistEnhancementRunning) {
      return;
    }

    enhanceWishlistSelects();
    enhanceWishlistSearchIcons();
    enhanceWishlistRegistryPickerLabels();
    enhanceWishlistTabLabels();

    if (
      document.querySelector(wishlistBulkRootSelector + ' .wl-skel-card') &&
      !document.querySelector(wishlistBulkRootSelector + ' .wl-card')
    ) {
      scheduleWishlistEnhancements(260);
      return;
    }

    wishlistEnhancementRunning = true;

    try {
      enhanceWishlistMoveDropdowns();
      enhanceWishlistPopupSheets();
      updateWishlistEmptyCopy();
      updateWishlistServiceButtons();
      markWishlistRemoveAllModals();
      markWishlistAddCartConfirms();
      syncAllWishlistBulkActionLabels();
    } finally {
      wishlistEnhancementRunning = false;
    }
  }

  function scheduleWishlistEnhancements(delay) {
    window.clearTimeout(wishlistEnhancementTimer);

    if (wishlistEnhancementFrame) {
      window.cancelAnimationFrame(wishlistEnhancementFrame);
      wishlistEnhancementFrame = null;
    }

    if (delay) {
      wishlistEnhancementTimer = window.setTimeout(runWishlistEnhancements, delay);
      return;
    }

    wishlistEnhancementFrame = window.requestAnimationFrame(function () {
      wishlistEnhancementFrame = null;
      runWishlistEnhancements();
    });
  }

  function mutationTouchesWishlist(mutation) {
    var target = mutation.target;

    if (target && target.closest && target.closest(wishlistBulkRootSelector + ', .wl-modal')) {
      return true;
    }

    return Array.prototype.some.call(mutation.addedNodes, function (node) {
      if (!node || node.nodeType !== 1) {
        return false;
      }

      return (
        node.matches?.(wishlistBulkRootSelector + ', .wl-modal, .wl-card, .wl-page__container') ||
        node.querySelector?.(wishlistBulkRootSelector + ', .wl-modal, .wl-card, .wl-page__container')
      );
    });
  }

  function observeWishlistEnhancements() {
    if (!('MutationObserver' in window)) {
      return;
    }

    new MutationObserver(function (mutations) {
      if (mutations.some(mutationTouchesWishlist)) {
        scheduleWishlistEnhancements();
      }
    }).observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  /* Initial one-time enhancement passes. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateChizyCartButtonLabels);
  } else {
    updateChizyCartButtonLabels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceSignupButtonInteraction);
  } else {
    enhanceSignupButtonInteraction();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceVariantSelectionIndicator);
  } else {
    enhanceVariantSelectionIndicator();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceVariantActiveValuePreview);
  } else {
    enhanceVariantActiveValuePreview();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceJudgeMeSortSelects);
  } else {
    enhanceJudgeMeSortSelects();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observeWishlistEnhancements();
      scheduleWishlistEnhancements();
    });
  } else {
    observeWishlistEnhancements();
    scheduleWishlistEnhancements();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatYmqPriceDisclaimers);
  } else {
    formatYmqPriceDisclaimers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreYmqNativePriceDisclaimers);
  } else {
    restoreYmqNativePriceDisclaimers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatYmqProductPriceDisclaimers);
  } else {
    formatYmqProductPriceDisclaimers();
  }

  function runGlobalEnhancements() {
    globalEnhancementFrame = null;

    enhanceCartCheckoutInteraction();
    enhanceSignupButtonInteraction();
    enhanceVariantSelectionIndicator();
    enhanceVariantActiveValuePreview();
    enhanceJudgeMeSortSelects();
    updateChizyCartButtonLabels();
    formatYmqPriceDisclaimers();
    restoreYmqNativePriceDisclaimers();
    formatYmqProductPriceDisclaimers();
  }

  function scheduleGlobalEnhancements() {
    if (globalEnhancementFrame) {
      return;
    }

    if (isNativeDrawerOrOverlayActive()) {
      return;
    }

    globalEnhancementFrame = window.requestAnimationFrame(runGlobalEnhancements);
  }

  function getNativeDrawerOverlaySelector() {
    return [
      'body-element.body-overlay',
      '#CartDrawer',
      '#DrawerMenu',
      '#SearchSidebar',
      '#SidebarFiltersDesktop',
      '#SidebarFiltersMobile',
      '#SortListSidebar',
      '#Quick-view',
      '.modal',
      '.product-information-drawer',
      '.wl-drawer',
      '.wl-popup',
      '.wl-modal'
    ].join(',');
  }

  function isNativeDrawerOrOverlayActive() {
    return Boolean(document.querySelector([
      'body-element.body-overlay.visible',
      '#CartDrawer.is-opened',
      '#DrawerMenu.is-opened',
      '#SearchSidebar.is-opened',
      '#SidebarFiltersDesktop.is-opened',
      '#SidebarFiltersMobile.is-opened',
      '#SortListSidebar.is-opened',
      '#Quick-view.is-opened',
      '.modal.is-opened',
      '.product-information-drawer.is-opened',
      '.wl-drawer',
      '.wl-popup',
      '.wl-modal'
    ].join(',')));
  }

  function isNativeDrawerOrOverlayMutation(mutation) {
    return mutation.target instanceof Element && Boolean(mutation.target.closest(getNativeDrawerOverlaySelector()));
  }

  /*
   * Global app mutation resync.
   * Keep it away from native drawer/overlay transitions so glass surfaces can animate on the
   * browser compositor without this file rescheduling unrelated enhancement work mid-flight.
   */
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      if (isNativeDrawerOrOverlayActive()) {
        return;
      }

      if (mutations.length && mutations.every(isNativeDrawerOrOverlayMutation)) {
        return;
      }

      scheduleGlobalEnhancements();
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style']
    });
  }

  /* Wishlist page/search icon and empty-copy polish. */
  function enhanceWishlistSearchIcons() {
    document.querySelectorAll('.wl-pub-search-icon').forEach(function (icon) {
      if (icon.getAttribute(wishlistSearchIconEnhancedAttribute) === 'true') {
        return;
      }

      icon.setAttribute('viewBox', '0 0 24 26');
      icon.setAttribute('width', '24');
      icon.setAttribute('height', '24');
      icon.innerHTML = '<path d="M21 21.8864L17.5096 18.3963M17.5096 18.3963C19.0471 16.8581 19.998 14.7335 19.998 12.3867C19.998 7.6923 16.1929 3.88672 11.499 3.88672C6.80514 3.88672 3 7.6923 3 12.3867C3 17.0811 6.80514 20.8867 11.499 20.8867C13.8464 20.8867 15.9715 19.935 17.5096 18.3963Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>';
      icon.setAttribute(wishlistSearchIconEnhancedAttribute, 'true');
    });

    document.querySelectorAll('.wl-pub-empty__icon').forEach(function (icon) {
      if (icon.getAttribute(wishlistSearchIconEnhancedAttribute) === 'true') {
        return;
      }

      icon.innerHTML = wishlistSearchIconSvg;
      icon.setAttribute(wishlistSearchIconEnhancedAttribute, 'true');
    });
  }

  function enhanceWishlistRegistryPickerLabels() {
    document.querySelectorAll('.wl-page__container .wl-pub-select').forEach(function (select) {
      var label = select.querySelector('.wl-pub-select__label') || select;
      var text = (label.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

      if (
        !text ||
        text.indexOf('search public wishlist') !== -1 ||
        text.indexOf('select public wishlist') !== -1
      ) {
        label.textContent = wishlistRegistryPlaceholderText;
      }
    });
  }

  function enhanceWishlistTabLabels() {
    document.querySelectorAll('.wl-page__container [data-wl-tab]').forEach(function (tab) {
      if (tab.getAttribute('data-wl-tab') === 'private') {
        tab.textContent = wishlistPrivateTabText;
      }

      if (tab.getAttribute('data-wl-tab') === 'public') {
        tab.textContent = wishlistPublicTabText;
      }
    });
  }

  function enhanceWishlistMoveDropdowns() {
    document.querySelectorAll('.wl-modal .wl-move-list-options').forEach(function (list) {
      var labels;
      var selectedIndex;
      var select;

      if (list.getAttribute(wishlistMoveDropdownEnhancedAttribute) === 'true') {
        return;
      }

      labels = Array.prototype.slice.call(list.querySelectorAll('.wl-move-list-option'));

      if (!labels.length || !list.parentNode) {
        return;
      }

      selectedIndex = labels.findIndex(function (label) {
        var input = label.querySelector('input[type="radio"]');
        return input && input.checked;
      });

      if (selectedIndex < 0) {
        selectedIndex = 0;
      }

      select = document.createElement('select');
      select.className = 'wl-list-select mystic-wishlist-move-select';
      select.setAttribute('aria-label', 'Move to wishlist');

      labels.forEach(function (label, index) {
        var option = document.createElement('option');
        var name = label.querySelector('.wl-move-list-name');
        var input = label.querySelector('input[type="radio"]');

        option.value = String(index);
        option.textContent = (name || label).textContent.trim();

        if (input && input.disabled) {
          option.disabled = true;
        }

        select.appendChild(option);
      });

      select.value = String(selectedIndex);

      select.addEventListener('change', function () {
        var label = labels[parseInt(select.value, 10)];
        var input = label && label.querySelector('input[type="radio"]');

        if (!label) {
          return;
        }

        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          label.click();
        }
      });

      list.parentNode.insertBefore(select, list);
      list.classList.add(wishlistMoveDropdownHiddenClass);
      list.setAttribute(wishlistMoveDropdownEnhancedAttribute, 'true');

      enhanceWishlistSelect(select);

      if (select.closest('.' + wishlistSelectWrapperClass)) {
        select.closest('.' + wishlistSelectWrapperClass).classList.add('mystic-wishlist-select--move-modal');
      }

      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function updateWishlistEmptyCopy() {
    document.querySelectorAll('.wl-empty__title').forEach(function (title) {
      if (title.textContent.trim().toLowerCase() === 'no favourites added yet') {
        title.textContent = 'Keep what resonates';
      }
    });

    document.querySelectorAll('.wl-popup__empty-title').forEach(function (title) {
      if (title.textContent.trim().toLowerCase() === 'no favourites added yet') {
        title.textContent = 'Keep what resonates';
      }
    });

    document.querySelectorAll('.wl-empty__explore-btn').forEach(function (button) {
      button.style.removeProperty('background');
      button.style.removeProperty('color');
      button.style.removeProperty('border');
    });
  }

  /* Wishlist custom dropdown/select replacement. */
  function closeWishlistSelect(wrapper) {
    var menu = wrapper && document.getElementById(wrapper.getAttribute('data-mystic-menu-id'));

    if (menu) {
      menu.setAttribute('hidden', '');
    }

    if (wrapper) {
      wrapper.classList.remove(wishlistSelectOpenClass);
      wrapper.querySelector('.' + wishlistSelectButtonClass)?.setAttribute('aria-expanded', 'false');
    }
  }

  function closeOtherWishlistSelects(activeWrapper) {
    document.querySelectorAll('.' + wishlistSelectWrapperClass + '.' + wishlistSelectOpenClass).forEach(function (wrapper) {
      if (wrapper !== activeWrapper) {
        closeWishlistSelect(wrapper);
      }
    });
  }

  function positionWishlistSelectMenu(wrapper, menu) {
    var button = wrapper.querySelector('.' + wishlistSelectButtonClass);
    var rect;
    var maxHeight;
    var menuWidth;

    if (!button || !menu) {
      return;
    }

    rect = button.getBoundingClientRect();
    menuWidth = Math.round(rect.width);

    maxHeight = Math.max(180, window.innerHeight - rect.bottom - 18);

    menu.style.setProperty('--mystic-wishlist-select-width', menuWidth + 'px');
    menu.style.left = Math.round(rect.left) + 'px';
    menu.style.top = Math.round(rect.bottom + 8) + 'px';
    menu.style.maxHeight = Math.min(320, maxHeight) + 'px';
    menu.style.zIndex = '1000035';
  }

  function syncWishlistSelectLabel(select, wrapper) {
    var label = wrapper.querySelector('.' + wishlistSelectLabelClass);
    var selectedOption = select.options[select.selectedIndex];

    if (label && selectedOption) {
      label.textContent = selectedOption.textContent.trim();
    }
  }

  function renderWishlistSelectOptions(select, wrapper, menu) {
    var selectedValue = select.value;

    menu.textContent = '';

    Array.prototype.forEach.call(select.options, function (option) {
      var item = document.createElement('button');

      item.type = 'button';
      item.className = wishlistSelectOptionClass;
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', option.value === selectedValue ? 'true' : 'false');

      item.appendChild(document.createTextNode(option.textContent.trim()));

      if (option.disabled) {
        item.disabled = true;
      }

      item.addEventListener('click', function () {
        if (select.value !== option.value) {
          select.value = option.value;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }

        syncWishlistSelectLabel(select, wrapper);
        closeWishlistSelect(wrapper);
      });

      menu.appendChild(item);
    });
  }

  function enhanceWishlistSelect(select) {
    var wrapper;
    var viewRow;
    var button;
    var label;
    var menu;
    var menuId;
    var isVariantSelect;

    if (!select || select.getAttribute(wishlistSelectEnhancedAttribute) === 'true') {
      return;
    }

    isVariantSelect = select.classList.contains('wl-card__variant-select');
    wrapper = document.createElement('span');
    wrapper.className = wishlistSelectWrapperClass;

    if (isVariantSelect) {
      wrapper.classList.add(wishlistVariantSelectClass);
    }

    menuId = 'mystic-wishlist-select-menu-' + Math.random().toString(36).slice(2);
    wrapper.setAttribute('data-mystic-menu-id', menuId);

    button = document.createElement('button');
    button.type = 'button';
    button.className = wishlistSelectButtonClass;
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');

    label = document.createElement('span');
    label.className = wishlistSelectLabelClass;
    button.appendChild(label);

    menu = document.createElement('div');
    menu.id = menuId;
    menu.className = wishlistSelectMenuClass;

    if (isVariantSelect) {
      menu.classList.add('mystic-wishlist-select-menu--variant');
    }

    menu.setAttribute('role', 'listbox');
    menu.setAttribute('hidden', '');

    if (isVariantSelect) {
      viewRow = document.createElement('span');
      viewRow.className = wishlistVariantViewRowClass;
      select.parentNode.insertBefore(viewRow, select);
      viewRow.appendChild(wrapper);
    } else {
      select.parentNode.insertBefore(wrapper, select);
    }

    wrapper.appendChild(select);
    wrapper.appendChild(button);

    document.body.appendChild(menu);

    select.setAttribute(wishlistSelectEnhancedAttribute, 'true');
    syncWishlistSelectLabel(select, wrapper);
    renderWishlistSelectOptions(select, wrapper, menu);

    if (isVariantSelect) {
      updateWishlistCardImageLink(select);
      updateWishlistCardVariantImage(select);
    }

    button.addEventListener('click', function () {
      var isOpen = wrapper.classList.contains(wishlistSelectOpenClass);

      closeOtherWishlistSelects(wrapper);

      if (isOpen) {
        closeWishlistSelect(wrapper);
        return;
      }

      renderWishlistSelectOptions(select, wrapper, menu);
      positionWishlistSelectMenu(wrapper, menu);
      menu.removeAttribute('hidden');
      wrapper.classList.add(wishlistSelectOpenClass);
      button.setAttribute('aria-expanded', 'true');
    });

    select.addEventListener('change', function () {
      if (select.classList.contains('wl-list-select')) {
        holdWishlistPopupBodyHeight(select);
      }

      syncWishlistSelectLabel(select, wrapper);
      renderWishlistSelectOptions(select, wrapper, menu);

      if (isVariantSelect) {
        updateWishlistCardImageLink(select);
        updateWishlistCardVariantImage(select);
      }
    });
  }

  function enhanceWishlistSelects() {
    document.querySelectorAll(wishlistSelectSelector).forEach(enhanceWishlistSelect);
    preloadWishlistCardProductData();

    document.querySelectorAll('.' + wishlistSelectMenuClass).forEach(function (menu) {
      if (!document.querySelector('.' + wishlistSelectWrapperClass + '[data-mystic-menu-id="' + menu.id + '"]')) {
        menu.remove();
      }
    });
  }

  /* Judge.me sort dropdown skin. Keeps the app's native select as the source of truth. */
  function closeJudgeMeSort(wrapper) {
    var menu = wrapper && document.getElementById(wrapper.getAttribute('data-mystic-judgeme-menu-id'));

    if (menu) {
      menu.setAttribute('hidden', '');
    }

    if (!wrapper) {
      return;
    }

    wrapper.classList.remove(judgeMeSortOpenClass);
    wrapper.querySelector('.' + judgeMeSortButtonClass)?.setAttribute('aria-expanded', 'false');
  }

  function closeOtherJudgeMeSorts(activeWrapper) {
    document.querySelectorAll('.' + judgeMeSortWrapperClass + '.' + judgeMeSortOpenClass).forEach(function (wrapper) {
      if (wrapper !== activeWrapper) {
        closeJudgeMeSort(wrapper);
      }
    });
  }

  function positionJudgeMeSortMenu(wrapper, menu) {
    var button = wrapper && wrapper.querySelector('.' + judgeMeSortButtonClass);
    var rect;
    var maxHeight;

    if (!button || !menu) {
      return;
    }

    rect = button.getBoundingClientRect();
    maxHeight = Math.max(180, window.innerHeight - rect.bottom - 18);

    menu.style.left = Math.round(rect.left) + 'px';
    menu.style.top = Math.round(rect.bottom + 8) + 'px';
    menu.style.width = Math.round(rect.width) + 'px';
    menu.style.maxHeight = Math.min(320, maxHeight) + 'px';
  }

  function syncJudgeMeSortLabel(select, wrapper) {
    var label = wrapper && wrapper.querySelector('.' + judgeMeSortLabelClass);
    var selectedOption = select && select.options[select.selectedIndex];

    if (label && selectedOption) {
      label.textContent = selectedOption.textContent.trim();
    }
  }

  function renderJudgeMeSortOptions(select, wrapper, menu) {
    var selectedValue = select.value;

    menu.textContent = '';

    Array.prototype.forEach.call(select.options, function (option) {
      var item = document.createElement('button');

      item.type = 'button';
      item.className = judgeMeSortOptionClass;
      item.textContent = option.textContent.trim();
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', option.value === selectedValue ? 'true' : 'false');

      if (option.disabled) {
        item.disabled = true;
      }

      item.addEventListener('click', function () {
        if (select.value !== option.value) {
          select.value = option.value;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }

        syncJudgeMeSortLabel(select, wrapper);
        renderJudgeMeSortOptions(select, wrapper, menu);
        closeJudgeMeSort(wrapper);
      });

      menu.appendChild(item);
    });
  }

  function enhanceJudgeMeSortSelect(select) {
    var wrapper;
    var button;
    var label;
    var menu;
    var menuId;

    if (!select || select.getAttribute(judgeMeSortEnhancedAttribute) === 'true') {
      return;
    }

    wrapper = document.createElement('span');
    wrapper.className = judgeMeSortWrapperClass;
    menuId = 'mystic-judgeme-sort-menu-' + Math.random().toString(36).slice(2);
    wrapper.setAttribute('data-mystic-judgeme-menu-id', menuId);

    button = document.createElement('button');
    button.type = 'button';
    button.className = judgeMeSortButtonClass;
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');

    label = document.createElement('span');
    label.className = judgeMeSortLabelClass;
    button.appendChild(label);

    menu = document.createElement('div');
    menu.id = menuId;
    menu.className = judgeMeSortMenuClass;
    menu.setAttribute('role', 'listbox');
    menu.setAttribute('hidden', '');

    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);
    wrapper.appendChild(button);
    document.body.appendChild(menu);

    select.setAttribute(judgeMeSortEnhancedAttribute, 'true');
    syncJudgeMeSortLabel(select, wrapper);
    renderJudgeMeSortOptions(select, wrapper, menu);

    button.addEventListener('click', function () {
      var isOpen = wrapper.classList.contains(judgeMeSortOpenClass);

      closeOtherJudgeMeSorts(wrapper);

      if (isOpen) {
        menu.setAttribute('hidden', '');
        closeJudgeMeSort(wrapper);
        return;
      }

      syncJudgeMeSortLabel(select, wrapper);
      renderJudgeMeSortOptions(select, wrapper, menu);
      positionJudgeMeSortMenu(wrapper, menu);
      menu.removeAttribute('hidden');
      wrapper.classList.add(judgeMeSortOpenClass);
      button.setAttribute('aria-expanded', 'true');
    });

    select.addEventListener('change', function () {
      syncJudgeMeSortLabel(select, wrapper);
      renderJudgeMeSortOptions(select, wrapper, menu);
    });
  }

  function enhanceJudgeMeSortSelects() {
    document.querySelectorAll(judgeMeSortSelectSelector).forEach(enhanceJudgeMeSortSelect);

    document.querySelectorAll('.' + judgeMeSortMenuClass).forEach(function (menu) {
      if (!document.querySelector('.' + judgeMeSortWrapperClass + '[data-mystic-judgeme-menu-id="' + menu.id + '"]')) {
        menu.remove();
      }
    });
  }

  function closeWishlistSelectsFromOutsideInteraction(event) {
    if (
      event.target
      && (
        event.target.closest('.' + wishlistSelectWrapperClass)
        || event.target.closest('.' + wishlistSelectMenuClass)
      )
    ) {
      return;
    }

    closeOtherWishlistSelects(null);
  }

  document.addEventListener('pointerdown', closeWishlistSelectsFromOutsideInteraction, true);
  document.addEventListener('click', closeWishlistSelectsFromOutsideInteraction, true);

  function closeJudgeMeSortsFromOutsideInteraction(event) {
    if (
      event.target
      && (
        event.target.closest('.' + judgeMeSortWrapperClass)
        || event.target.closest('.' + judgeMeSortMenuClass)
      )
    ) {
      return;
    }

    closeOtherJudgeMeSorts(null);
  }

  document.addEventListener('pointerdown', closeJudgeMeSortsFromOutsideInteraction, true);
  document.addEventListener('click', closeJudgeMeSortsFromOutsideInteraction, true);

  window.addEventListener('scroll', function () {
    closeOtherJudgeMeSorts(null);
  }, { passive: true });

  document.addEventListener('scroll', function (event) {
    if (
      event.target
      && event.target.closest
      && event.target.closest('.' + judgeMeSortMenuClass)
    ) {
      return;
    }

    closeOtherJudgeMeSorts(null);
  }, true);

  window.addEventListener('resize', function () {
    closeOtherJudgeMeSorts(null);
  }, { passive: true });

  function getWishlistBulkRoot(element) {
    return element && element.closest ? element.closest(wishlistBulkRootSelector) : null;
  }

  function getWishlistSelectedCount(root) {
    return root ? root.querySelectorAll('.wl-card__check:checked').length : 0;
  }

  function setWishlistButtonText(button, text) {
    if (!button) {
      return;
    }

    if (button.textContent.trim() !== text) {
      button.textContent = text;
    }

    button.setAttribute('aria-label', text);
  }

  function getWishlistSelectionDrawer(root) {
    return root && root.querySelector('[data-mystic-wishlist-selection-drawer]');
  }

  function getWishlistVisibleCards(root) {
    return root ? Array.from(root.querySelectorAll('.wl-card')).filter(function (card) {
      return card.offsetParent !== null;
    }) : [];
  }

  function getWishlistAddButtons(root, selectedOnly) {
    var cards = getWishlistVisibleCards(root);

    if (selectedOnly) {
      cards = cards.filter(function (card) {
        var checkbox = card.querySelector('.wl-card__check');

        return checkbox && checkbox.checked;
      });
    }

    return cards.map(function (card) {
      return card.querySelector('.wl-card__add-cart');
    }).filter(function (button) {
      return button && !button.disabled && button.getAttribute('aria-disabled') !== 'true';
    });
  }

  function createWishlistAddAllButton() {
    var button = document.createElement('button');

    button.type = 'button';
    button.className = 'wl-table__bulk-btn wl-table__bulk-btn--all mystic-wishlist-add-all';
    button.setAttribute('data-wl-page-add-all', 'true');
    button.textContent = 'Add All To Bag';

    return button;
  }

  function ensureWishlistAddAllButton(root) {
    var actions = root && root.querySelector('.wl-page__top-actions-right');
    var addButton = root && root.querySelector('[data-wl-page-add-all], .wl-table__bulk-btn--all');
    var controls = root && root.querySelector('.wl-page__controls');
    var actionRow;
    var removeButton;

    if (!root) {
      return addButton;
    }

    if (!actions) {
      actionRow = root.querySelector('.wl-page__top-actions');

      if (!actionRow) {
        actionRow = document.createElement('div');
        actionRow.className = 'wl-page__top-actions';

        if (controls) {
          controls.insertAdjacentElement('afterend', actionRow);
        } else {
          root.insertBefore(actionRow, root.firstChild);
        }
      }

      actions = document.createElement('div');
      actions.className = 'wl-page__top-actions-right';
      actionRow.appendChild(actions);
    }

    if (!addButton) {
      addButton = createWishlistAddAllButton();
      removeButton = actions.querySelector('[data-wl-page-empty], .wl-page__empty-btn');

      if (removeButton) {
        actions.insertBefore(addButton, removeButton);
      } else {
        actions.insertBefore(addButton, actions.firstChild);
      }
    }

    return addButton;
  }

  function getWishlistCurrentListId(root) {
    var listSelect = root && root.querySelector('.wl-list-select');
    return listSelect ? listSelect.value : '';
  }

  function wishlistMoveHasDestination(root) {
    var currentListId = getWishlistCurrentListId(root);
    var listSelect = root && root.querySelector('.wl-list-select');
    var bulkMoveOption = root && root.querySelector('.wl-page__bulk-select option[value="move_wishlist"]');
    var destinationOptions;

    if (!listSelect || !bulkMoveOption) {
      return false;
    }

    destinationOptions = Array.from(listSelect.options || []).filter(function (option) {
      return !option.disabled && option.value && option.value !== currentListId;
    });

    return destinationOptions.length > 0;
  }

  function createWishlistSelectionDrawer() {
    var drawer = document.createElement('div');
    var moveButton = document.createElement('button');
    var clearButton = document.createElement('button');

    drawer.className = 'mystic-wishlist-selection-drawer';
    drawer.setAttribute('data-mystic-wishlist-selection-drawer', 'true');
    drawer.setAttribute('aria-hidden', 'true');

    moveButton.type = 'button';
    moveButton.className = 'mystic-wishlist-selection-drawer__button';
    moveButton.setAttribute('data-mystic-wishlist-selection-move', 'true');
    moveButton.textContent = 'Move Selected';

    clearButton.type = 'button';
    clearButton.className = 'mystic-wishlist-selection-drawer__button';
    clearButton.setAttribute('data-mystic-wishlist-selection-clear', 'true');
    clearButton.textContent = 'Unselect All';

    drawer.append(moveButton, clearButton);
    return drawer;
  }

  function ensureWishlistSelectionDrawer(root) {
    var actions = root && root.querySelector('.wl-page__top-actions, .wl-popup__top-bar');
    var actionButtons = root && root.querySelector('.wl-page__top-actions-right');
    var drawer;
    var drawerParent = actionButtons || (actions && actions.parentElement);

    if (!root || !actions || !drawerParent) {
      return null;
    }

    drawer = getWishlistSelectionDrawer(root);

    if (!drawer) {
      drawer = createWishlistSelectionDrawer();
    }

    if (actionButtons && drawer.parentElement !== actionButtons) {
      actionButtons.appendChild(drawer);
    } else if (!actionButtons && drawer.previousElementSibling !== actions) {
      actions.insertAdjacentElement('afterend', drawer);
    }

    return drawer;
  }

  function syncWishlistBulkActionLabels(root) {
    var selectedCount = getWishlistSelectedCount(root);
    var addButton = ensureWishlistAddAllButton(root);
    var removeButton = root && root.querySelector('[data-wl-page-empty], .wl-page__empty-btn');
    var selectionDrawer = ensureWishlistSelectionDrawer(root);
    var moveButton = selectionDrawer && selectionDrawer.querySelector('[data-mystic-wishlist-selection-move]');
    var canMove = wishlistMoveHasDestination(root);
    var addableCount = getWishlistAddButtons(root, selectedCount > 0).length;

    if (!root) {
      return;
    }

    root.classList.toggle(wishlistBulkSelectedClass, selectedCount > 0);
    setWishlistButtonText(addButton, selectedCount > 0 ? 'Add Selected' : 'Add All To Bag');
    setWishlistButtonText(removeButton, selectedCount > 0 ? 'Remove Selected' : 'Remove All');

    if (selectionDrawer) {
      selectionDrawer.classList.toggle('is-open', selectedCount > 0);
      selectionDrawer.setAttribute('aria-hidden', selectedCount > 0 ? 'false' : 'true');
    }

    if (moveButton) {
      moveButton.disabled = !canMove;
      moveButton.setAttribute('aria-disabled', canMove ? 'false' : 'true');
      moveButton.classList.toggle('is-disabled', !canMove);
    }

    if (addButton) {
      addButton.disabled = addableCount <= 0;
      addButton.setAttribute('aria-disabled', addableCount > 0 ? 'false' : 'true');
      addButton.classList.toggle('is-disabled', addableCount <= 0);
    }
  }

  function syncAllWishlistBulkActionLabels() {
    document.querySelectorAll(wishlistBulkRootSelector).forEach(syncWishlistBulkActionLabels);
  }

  function runWishlistBulkAction(root, action) {
    var select = root && root.querySelector('.wl-page__bulk-select');
    var applyButton = root && root.querySelector('.wl-page__bulk-apply');

    if (!select || !applyButton) {
      return false;
    }

    if (select.value !== action) {
      select.value = action;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    applyButton.click();
    return true;
  }

  function runWishlistAddAllAction(root, selectedOnly) {
    var buttons;

    if (runWishlistBulkAction(root, 'add_cart')) {
      return true;
    }

    buttons = getWishlistAddButtons(root, selectedOnly);

    if (!buttons.length) {
      return false;
    }

    buttons.forEach(function (button, index) {
      window.setTimeout(function () {
        button.click();
      }, index * 90);
    });

    return true;
  }

  function scheduleWishlistBulkActionSync() {
    [0, 180, 520, 1100].forEach(function (delay) {
      window.setTimeout(syncAllWishlistBulkActionLabels, delay);
    });
  }

  document.addEventListener('change', function (event) {
    var checkbox = event.target && event.target.closest && event.target.closest('.wl-card__check');
    var root;

    if (!checkbox) {
      return;
    }

    root = getWishlistBulkRoot(checkbox);
    syncWishlistBulkActionLabels(root);
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target;
    var root = getWishlistBulkRoot(target);
    var selectedCount = getWishlistSelectedCount(root);
    var addButton;
    var removeButton;
    var moveButton;
    var clearButton;

    if (!root) {
      return;
    }

    addButton = target && target.closest && target.closest('[data-wl-page-add-all], .wl-table__bulk-btn--all');
    removeButton = target && target.closest && target.closest('[data-wl-page-empty], .wl-page__empty-btn');
    moveButton = target && target.closest && target.closest('[data-mystic-wishlist-selection-move]');
    clearButton = target && target.closest && target.closest('[data-mystic-wishlist-selection-clear]');

    if (!addButton && !removeButton && !moveButton && !clearButton) {
      return;
    }

    if (selectedCount <= 0 && !addButton) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (clearButton) {
      root.querySelectorAll('.wl-card__check:checked').forEach(function (checkbox) {
        checkbox.checked = false;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      });
    } else if (addButton) {
      runWishlistAddAllAction(root, selectedCount > 0);
    } else if (moveButton && !wishlistMoveHasDestination(root)) {
      syncWishlistBulkActionLabels(root);
    } else {
      runWishlistBulkAction(root, moveButton ? 'move_wishlist' : 'remove_selected');
    }

    window.setTimeout(function () {
      syncWishlistBulkActionLabels(root);
    }, 240);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleWishlistBulkActionSync);
  } else {
    scheduleWishlistBulkActionSync();
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeOtherWishlistSelects(null);
    }
  });

  window.addEventListener('resize', function () {
    closeOtherWishlistSelects(null);
  });

  window.addEventListener(
    'scroll',
    function (event) {
      if (
        event.target
        && event.target.closest
        && event.target.closest('.' + wishlistSelectMenuClass)
      ) {
        return;
      }

      closeOtherWishlistSelects(null);
    },
    true
  );

  /* Cart drawer checkout button hover/active proxy. */
  function bindCartCheckoutInteractionTarget(target, button) {
    if (!target || target.getAttribute(cartCheckoutBoundAttribute) === 'true') {
      return;
    }

    target.setAttribute(cartCheckoutBoundAttribute, 'true');

    target.addEventListener('mouseover', function () {
      button.classList.add(cartButtonHoverClass);
    });

    target.addEventListener('mouseout', function (event) {
      if (event.relatedTarget && target.contains(event.relatedTarget)) {
        return;
      }

      button.classList.remove(cartButtonHoverClass);
      button.classList.remove(cartButtonActiveClass);
    });

    target.addEventListener('mousedown', function () {
      button.classList.add(cartButtonActiveClass);
    });

    ['mouseup', 'mouseleave', 'blur'].forEach(function (eventName) {
      target.addEventListener(eventName, function () {
        button.classList.remove(cartButtonActiveClass);
      });
    });
  }

  function enhanceCartCheckoutInteraction() {
    document.querySelectorAll(cartCheckoutSelector).forEach(function (button) {
      button.style.setProperty('pointer-events', 'auto', 'important');

      if (button.getAttribute(cartCheckoutInteractionAttribute) !== 'true') {
        button.setAttribute(cartCheckoutInteractionAttribute, 'true');
      }

      bindCartCheckoutInteractionTarget(button, button);
      bindCartCheckoutInteractionTarget(button.parentElement, button);
    });
  }

  /* Signup lightbox button hover/active proxy. */
  function enhanceSignupButtonInteraction() {
    if (document.documentElement.getAttribute(signupPointerMoveBoundAttribute) !== 'true') {
      document.documentElement.setAttribute(signupPointerMoveBoundAttribute, 'true');

      document.addEventListener('mousemove', function (event) {
        if (isNativeDrawerOrOverlayActive()) {
          return;
        }

        var targetButton = document
          .elementFromPoint(event.clientX, event.clientY)
          ?.closest(signupButtonSelector);

        document.querySelectorAll(signupButtonSelector).forEach(function (button) {
          button.classList.toggle(signupButtonHoverClass, button === targetButton);

          if (button !== targetButton) {
            button.classList.remove(signupButtonActiveClass);
          }
        });
      });
    }

    document.querySelectorAll(signupButtonSelector).forEach(function (button) {
      if (button.getAttribute(signupButtonBoundAttribute) === 'true') {
        return;
      }

      button.setAttribute(signupButtonBoundAttribute, 'true');

      ['mouseenter', 'mouseover', 'focus', 'focusin'].forEach(function (eventName) {
        button.addEventListener(eventName, function () {
          button.classList.add(signupButtonHoverClass);
        });
      });

      ['mouseleave', 'mouseout', 'blur', 'focusout'].forEach(function (eventName) {
        button.addEventListener(eventName, function (event) {
          if (event.relatedTarget && button.contains(event.relatedTarget)) {
            return;
          }

          button.classList.remove(signupButtonHoverClass);
          button.classList.remove(signupButtonActiveClass);
        });
      });

      ['mousedown', 'touchstart', 'pointerdown'].forEach(function (eventName) {
        button.addEventListener(eventName, function () {
          button.classList.add(signupButtonActiveClass);
        });
      });

      ['mouseup', 'touchend', 'touchcancel', 'pointerup', 'pointercancel'].forEach(function (eventName) {
        button.addEventListener(eventName, function () {
          button.classList.remove(signupButtonActiveClass);
        });
      });
    });
  }

  /* Header inline search service cards/buttons touch and hover polish. */
  function enhanceSearchServiceButtonInteraction() {
    if (document.documentElement.getAttribute(searchServicePointerBoundAttribute) !== 'true') {
      document.documentElement.setAttribute(searchServicePointerBoundAttribute, 'true');

      ['pointerdown', 'mousedown', 'touchstart'].forEach(function (eventName) {
        document.addEventListener(eventName, function (event) {
          var button = event.target.closest(searchServiceButtonSelector);

          if (!button) {
            return;
          }

          button.classList.add(searchServiceButtonActiveClass);

          window.setTimeout(function () {
            button.classList.remove(searchServiceButtonActiveClass);
          }, 140);
        }, true);
      });
    }

    document.querySelectorAll(searchServiceButtonSelector).forEach(function (button) {
      var buttonText = button.querySelector('.horizontal-product-card__button-text');

      if (buttonText) {
        buttonText.textContent = 'View';
      }

      button.setAttribute('aria-label', 'View');

      if (button.getAttribute(searchServiceButtonBoundAttribute) === 'true') {
        return;
      }

      button.setAttribute(searchServiceButtonBoundAttribute, 'true');

      ['mousedown', 'touchstart', 'pointerdown'].forEach(function (eventName) {
        button.addEventListener(eventName, function () {
          button.classList.add(searchServiceButtonActiveClass);
        });
      });

      ['mouseup', 'mouseleave', 'blur', 'touchend', 'touchcancel', 'pointerup', 'pointercancel'].forEach(function (eventName) {
        button.addEventListener(eventName, function () {
          button.classList.remove(searchServiceButtonActiveClass);
        });
      });
    });

    document.querySelectorAll(searchServiceCardSelector).forEach(function (card) {
      if (card.getAttribute(searchServiceCardBoundAttribute) === 'true') {
        return;
      }

      var button = card.querySelector(searchServiceButtonSelector);

      if (!button) {
        return;
      }

      card.setAttribute(searchServiceCardBoundAttribute, 'true');

      ['mouseenter', 'focusin'].forEach(function (eventName) {
        card.addEventListener(eventName, function () {
          button.classList.add(searchServiceButtonHoverClass);
        });
      });

      ['mouseleave', 'focusout'].forEach(function (eventName) {
        card.addEventListener(eventName, function () {
          button.classList.remove(searchServiceButtonHoverClass);
        });
      });
    });
  }

  function enhanceInlineSearchCardTouchInteraction() {
    if (document.documentElement.getAttribute(searchCardTouchAttribute) === 'true') {
      return;
    }

    document.documentElement.setAttribute(searchCardTouchAttribute, 'true');

    ['pointerdown', 'touchstart'].forEach(function (eventName) {
      document.addEventListener(eventName, function (event) {
        var card = event.target.closest(searchCardTouchSelector);

        if (!card) {
          return;
        }

        card.classList.add(searchCardTouchClass);
      }, true);
    });

    ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(function (eventName) {
      document.addEventListener(eventName, function (event) {
        var card = event.target.closest(searchCardTouchSelector);

        if (!card) {
          return;
        }

        window.setTimeout(function () {
          card.classList.remove(searchCardTouchClass);
        }, 120);
      }, true);
    });
  }

  /* Product variant selected-outline animation and active label preview. */
  function getVariantBorderElement(element) {
    var imageBody = element.querySelector('.image-swatches__item-body-wrapper');
    var colorSwatch = element.querySelector('.color-swatch');

    return imageBody || colorSwatch || element;
  }

  function getVariantIndicator(group) {
    var indicator = group.querySelector('.' + variantIndicatorClass);

    if (indicator) {
      return indicator;
    }

    indicator = document.createElement('span');
    indicator.className = variantIndicatorClass;
    indicator.setAttribute('aria-hidden', 'true');
    indicator.style.position = 'absolute';
    indicator.style.top = '0';
    indicator.style.left = '0';
    indicator.style.pointerEvents = 'none';
    group.appendChild(indicator);

    return indicator;
  }

  function scheduleVariantIndicatorSettledUpdates(group) {
    [120, 360, 800].forEach(function (delay) {
      window.setTimeout(function () {
        updateVariantIndicator(group, false);
      }, delay);
    });
  }

  function setPreferredVariantTarget(group, target) {
    if (!group || !target) {
      return;
    }

    variantPreferredTargets.set(group, {
      target: target,
      expiresAt: Date.now() + 900
    });
  }

  function getPreferredVariantTarget(group) {
    var preferred = variantPreferredTargets.get(group);

    if (!preferred) {
      return null;
    }

    if (Date.now() > preferred.expiresAt || !group.contains(preferred.target)) {
      variantPreferredTargets.delete(group);
      return null;
    }

    return preferred.target;
  }

  function positionVariantIndicator(group, target, animate) {
    var indicator = getVariantIndicator(group);
    var targetElement = getVariantBorderElement(target);
    var groupRect = group.getBoundingClientRect();
    var targetRect = targetElement.getBoundingClientRect();
    var styles = window.getComputedStyle(targetElement);
    var targetX = targetRect.left - groupRect.left;
    var targetY = targetRect.top - groupRect.top;

    if (!targetRect.width || !targetRect.height) {
      return;
    }

    if (!animate) {
      indicator.style.transition = 'none';
    } else {
      indicator.style.removeProperty('transition');
    }

    indicator.style.setProperty('--mystic-variant-indicator-x', targetX + 'px');
    indicator.style.setProperty('--mystic-variant-indicator-y', targetY + 'px');
    indicator.style.setProperty('--mystic-variant-indicator-width', targetRect.width + 'px');
    indicator.style.setProperty('--mystic-variant-indicator-height', targetRect.height + 'px');
    indicator.style.setProperty('--mystic-variant-indicator-radius', styles.borderRadius || '999px');
    indicator.style.setProperty('--mystic-variant-indicator-opacity', '1');
    group.classList.add(variantIndicatorReadyClass);

    if (!animate) {
      window.requestAnimationFrame(function () {
        indicator.style.removeProperty('transition');
      });
    }
  }

  function updateVariantIndicator(group, animate) {
    var selected = getPreferredVariantTarget(group) || group.querySelector(variantSelectedOptionSelector);

    if (!selected) {
      return;
    }

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        positionVariantIndicator(group, selected, animate);
      });
    });
  }

  function updateVariantIndicatorToTarget(group, target, animate) {
    if (!group || !target) {
      return;
    }

    setPreferredVariantTarget(group, target);

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        positionVariantIndicator(group, target, animate);
      });
    });
  }

  function moveVariantIndicatorToEventTarget(event) {
    if (event.pointerType === 'touch' || event.pointerType === 'pen') {
      return;
    }

    var target = event.target.closest(variantOptionSelector);
    var group = target ? target.closest(variantOptionGroupSelector) : null;

    if (!target || !group) {
      return;
    }

    setPreferredVariantTarget(group, target);
    positionVariantIndicator(group, target, true);
  }

  function moveVariantIndicatorToSyncedPicker(event) {
    var picker = event.target && event.target.matches('variant-picker.product-variant-picker')
      ? event.target
      : event.target?.closest('variant-picker.product-variant-picker');

    if (!picker) {
      return;
    }

    picker.querySelectorAll(variantOptionGroupSelector).forEach(function (group) {
      updateVariantIndicator(group, true);
    });
  }

  function getVariantOptionValue(option) {
    return (option?.getAttribute('data-value') || option?.textContent || '').trim();
  }

  function setVariantActiveValue(option, useSelected) {
    var labelContainer = option?.closest('[data-variant-picker-option-labels]');
    var activeValue = labelContainer?.querySelector('.product-variant-picker__option-active-color');
    var selectedOption = useSelected
      ? labelContainer?.querySelector('.pill.selected, .image-swatches__item.selected, .color-swatch-select-parent.selected')
      : option;
    var value = getVariantOptionValue(selectedOption);

    if (activeValue && value) {
      activeValue.textContent = value;
    }
  }

  function enhanceVariantActiveValuePreview() {
    var supportsRealHover = !window.matchMedia
      || (
        window.matchMedia('(hover: hover)').matches
        && window.matchMedia('(pointer: fine)').matches
      );

    document.querySelectorAll('variant-picker.product-variant-picker').forEach(function (picker) {
      if (picker.getAttribute(variantActiveValueBoundAttribute) === 'true') {
        return;
      }

      picker.setAttribute(variantActiveValueBoundAttribute, 'true');

      var lastPreviewOption = null;
      var suppressResetUntil = 0;

      function canResetToSelected() {
        return Date.now() > suppressResetUntil;
      }

      function resetActiveValues() {
        if (!canResetToSelected()) {
          return;
        }

        lastPreviewOption = null;

        picker.querySelectorAll('[data-variant-picker-option-labels]').forEach(function (labelContainer) {
          var selectedOption = labelContainer.querySelector(
            '.pill.selected, .image-swatches__item.selected, .color-swatch-select-parent.selected'
          );

          if (selectedOption) {
            setVariantActiveValue(selectedOption, true);
          }
        });
      }

      function previewOption(event) {
        var option = event.target.closest(variantOptionSelector);

        if (option && option !== lastPreviewOption && picker.contains(option)) {
          lastPreviewOption = option;
          setVariantActiveValue(option, false);
        }
      }

      function lockActiveValueToInteraction(event) {
        var option = event.target.closest(variantOptionSelector);

        if (!option || !picker.contains(option)) {
          return;
        }

        suppressResetUntil = Date.now() + 900;
        lastPreviewOption = option;
        setVariantActiveValue(option, false);

        window.requestAnimationFrame(function () {
          setVariantActiveValue(option, false);
        });

        window.setTimeout(function () {
          setVariantActiveValue(option, false);
        }, 40);

        window.setTimeout(function () {
          setVariantActiveValue(option, false);
        }, 120);
      }

      if (supportsRealHover) {
        picker.addEventListener('mouseover', previewOption);
        picker.addEventListener('mousemove', previewOption);
        picker.addEventListener('pointerdown', lockActiveValueToInteraction, true);
        picker.addEventListener('click', lockActiveValueToInteraction, true);
        picker.addEventListener('touchstart', lockActiveValueToInteraction, true);
        picker.addEventListener('mousedown', lockActiveValueToInteraction, true);

        document.addEventListener('mousemove', function (event) {
          if (isNativeDrawerOrOverlayActive()) {
            return;
          }

          if (
            lastPreviewOption
            && canResetToSelected()
            && !event.target.closest('variant-picker.product-variant-picker')
          ) {
            resetActiveValues();
          }
        });

        picker.addEventListener('mouseout', function (event) {
          var option = event.target.closest(variantOptionSelector);
          var relatedOption = event.relatedTarget?.closest(variantOptionSelector);

          if (option && option !== relatedOption && picker.contains(option) && canResetToSelected()) {
            lastPreviewOption = null;
            setVariantActiveValue(option, true);
          }
        });

        picker.addEventListener('mouseleave', resetActiveValues);
      }

      picker.addEventListener('change', function (event) {
        var option = event.target?.id
          ? picker.querySelector('label[for="' + event.target.id + '"]')
          : null;

        if (option) {
          suppressResetUntil = Date.now() + 500;
          lastPreviewOption = option;
          setVariantActiveValue(option, true);
        }
      });

      resetActiveValues();
    });
  }

  function enhanceVariantSelectionIndicator() {
    if (document.documentElement.getAttribute(variantPointerBoundAttribute) !== 'true') {
      document.documentElement.setAttribute(variantPointerBoundAttribute, 'true');

      ['pointerdown'].forEach(function (eventName) {
        document.addEventListener(eventName, moveVariantIndicatorToEventTarget, true);
      });
    }

    if (document.documentElement.getAttribute(variantSyncBoundAttribute) !== 'true') {
      document.documentElement.setAttribute(variantSyncBoundAttribute, 'true');

      document.addEventListener(variantSyncedEventName, moveVariantIndicatorToSyncedPicker);
    }

    document.querySelectorAll('variant-picker.product-variant-picker').forEach(function (picker) {
      if (picker.getAttribute(variantBorderBoundAttribute) === 'true') {
        return;
      }

      picker.setAttribute(variantBorderBoundAttribute, 'true');

      picker.querySelectorAll(variantOptionGroupSelector).forEach(function (group) {
        updateVariantIndicator(group, false);
        scheduleVariantIndicatorSettledUpdates(group);

        if (
          window.ResizeObserver
          && group.getAttribute(variantResizeBoundAttribute) !== 'true'
        ) {
          group.setAttribute(variantResizeBoundAttribute, 'true');

          new ResizeObserver(function () {
            updateVariantIndicator(group, false);
          }).observe(group);
        }
      });

      picker.addEventListener('change', function (event) {
        var target = event.target
          && event.target.id
          && picker.querySelector('label[for="' + event.target.id + '"]');
        var group = target?.closest(variantOptionGroupSelector);

        if (group) {
          updateVariantIndicatorToTarget(group, target, true);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      enhanceCartCheckoutInteraction();
      syncWishlistDrawerTrendingCarousel();
    });
  } else {
    enhanceCartCheckoutInteraction();
    syncWishlistDrawerTrendingCarousel();
  }

  /* Product-page and product-card wishlist button click animation and hover suppression. */
  function getMysticWishlistPressButton(target) {
    if (!target || !target.closest) {
      return null;
    }

    return target.closest('.product-form__purchase-row .wl-btn--product, .wl-tile-btn');
  }

  function clearProductWishlistPressState(button) {
    if (!button) {
      return;
    }

    button.classList.remove('mystic-wl-press-add');
    button.classList.remove('mystic-wl-press-remove');
  }

  function suppressProductWishlistHover(button) {
    if (!button) {
      return;
    }

    button.classList.add('mystic-wl-suppress-hover');
  }

  function clearProductWishlistHoverSuppress(button) {
    if (!button) {
      return;
    }

    button.classList.remove('mystic-wl-suppress-hover');
  }

  function handleProductWishlistPointerExit(event) {
    var button = getMysticWishlistPressButton(event.target);
    var nextTarget = event.relatedTarget;

    if (!button || (nextTarget && button.contains(nextTarget))) {
      return;
    }

    clearProductWishlistHoverSuppress(button);
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      var button = getMysticWishlistPressButton(event.target);
      var isSaved;

      if (!button) {
        return;
      }

      isSaved = button.classList.contains('wl-active') || /remove/i.test(button.getAttribute('aria-label') || '');

      clearProductWishlistPressState(button);
      button.classList.add(isSaved ? 'mystic-wl-press-remove' : 'mystic-wl-press-add');

      button.addEventListener(
        'pointerup',
        function () {
          suppressProductWishlistHover(button);
          window.setTimeout(function () {
            clearProductWishlistPressState(button);
          }, 180);
        },
        { once: true }
      );

      ['pointercancel', 'pointerleave'].forEach(function (eventName) {
        button.addEventListener(
          eventName,
          function () {
            window.setTimeout(function () {
              clearProductWishlistPressState(button);
            }, 180);
          },
          { once: true }
        );
      });
    },
    true
  );

  document.addEventListener(
    'pointerleave',
    handleProductWishlistPointerExit,
    true
  );

  document.addEventListener(
    'mouseleave',
    handleProductWishlistPointerExit,
    true
  );

  document.addEventListener(
    'pointermove',
    function (event) {
      document.querySelectorAll('.product-form__purchase-row .wl-btn--product.mystic-wl-suppress-hover, .wl-tile-btn.mystic-wl-suppress-hover').forEach(function (button) {
        if (button.contains(event.target)) {
          return;
        }

        clearProductWishlistHoverSuppress(button);
      });
    },
    true
  );

  /* Delegated wishlist/cart clicks: removes, service routing, drawer sync, and carousel refresh. */
  document.addEventListener(
    'click',
    function (event) {
      var removeButton = event.target && event.target.closest(wishlistPageRemoveSelector);
      var serviceChoiceButton = event.target && event.target.closest
        ? event.target.closest(wishlistServiceButtonSelector + '[' + wishlistServiceChoiceAttribute + '="true"]')
        : null;
      var serviceChoiceUrl;

      if (removeButton && removeButton.getAttribute(wishlistRemoveConfirmedAttribute) !== 'true') {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        openWishlistRemoveConfirm(removeButton);
        return;
      }

      if (serviceChoiceButton) {
        serviceChoiceUrl = serviceChoiceButton.getAttribute(wishlistServiceUrlAttribute);

        if (serviceChoiceUrl) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          window.location.href = serviceChoiceUrl;
          return;
        }
      }

      if (
        event.target
        && (
          event.target.closest('a[href*="/apps/wishlist"]')
          || event.target.closest('[data-wishlist]')
          || event.target.closest('[data-wishlist-btn]')
        )
      ) {
        [180, 520, 900, 1400].forEach(function (delay) {
          window.setTimeout(syncWishlistDrawerTrendingCarousel, delay);
        });
      }
    },
    true
  );

  /* Wishlist drawer Vibe Check / trending carousel normalization. */
  function getWishlistDrawerTrendingData(trending) {
    var track = trending && trending.querySelector('.wl-trending__track');
    var cards = trending ? Array.prototype.slice.call(trending.querySelectorAll('.wl-trending__card')) : [];
    var dots = trending ? Array.prototype.slice.call(trending.querySelectorAll('.wl-trending__dot')) : [];
    var pageCount = Math.ceil(cards.length / wishlistDrawerTrendingCardsPerPage);

    if (!track || cards.length <= wishlistDrawerTrendingCardsPerPage || pageCount <= 1) {
      return null;
    }

    return {
      track: track,
      cards: cards,
      dots: dots,
      pageCount: pageCount
    };
  }

  function getWishlistDrawerTrendingPage(trending, pageCount) {
    var storedPage = parseInt(trending.getAttribute(wishlistDrawerTrendingPageAttribute), 10);
    var track = trending.querySelector('.wl-trending__track');
    var inlineTransform = track ? track.style.transform || '' : '';
    var inlineMatch = inlineTransform.match(/translateX\((-?\d+(?:\.\d+)?)%\)/);
    var page = Number.isNaN(storedPage) ? 0 : storedPage;

    if (inlineMatch) {
      page = Math.round(Math.abs(parseFloat(inlineMatch[1])) / 100);
    }

    if (page >= pageCount) {
      page = 0;
    }

    return Math.max(0, Math.min(page, pageCount - 1));
  }

  function getWishlistDrawerTrendingRawPage(track) {
    var inlineTransform = track ? track.style.transform || '' : '';
    var inlineMatch = inlineTransform.match(/translateX\((-?\d+(?:\.\d+)?)%\)/);

    if (!inlineMatch) {
      return null;
    }

    return Math.round(Math.abs(parseFloat(inlineMatch[1])) / 100);
  }

  function setWishlistDrawerTrendingPage(trending, page, animate) {
    var data = getWishlistDrawerTrendingData(trending);

    if (!data) {
      return;
    }

    page = ((page % data.pageCount) + data.pageCount) % data.pageCount;
    trending.setAttribute(wishlistDrawerTrendingPageAttribute, String(page));

    if (animate === false) {
      data.track.style.transition = 'none';
    } else {
      data.track.style.transition = '';
    }

    data.track.style.transform = 'translateX(-' + (page * 100) + '%)';

    data.dots.forEach(function (dot, index) {
      var isVisibleDot = index < data.pageCount;
      var isActiveDot = index === page;

      dot.classList.toggle('wl-trending__dot--active', isActiveDot);
      dot.classList.toggle('is-active', isActiveDot);
      dot.setAttribute('aria-hidden', isVisibleDot ? 'false' : 'true');
      dot.tabIndex = isVisibleDot ? 0 : -1;
    });

    if (animate === false) {
      window.setTimeout(function () {
        data.track.style.transition = '';
      }, 30);
    }
  }

  function normalizeWishlistDrawerTrendingPage(trending) {
    var data = getWishlistDrawerTrendingData(trending);
    var rawPage;
    var normalizedPage;

    if (!data || data.track.getAttribute(wishlistDrawerTrendingNormalizingAttribute) === 'true') {
      return;
    }

    rawPage = getWishlistDrawerTrendingRawPage(data.track);

    if (rawPage === null) {
      return;
    }

    normalizedPage = ((rawPage % data.pageCount) + data.pageCount) % data.pageCount;

    if (rawPage !== normalizedPage) {
      data.track.setAttribute(wishlistDrawerTrendingNormalizingAttribute, 'true');
      setWishlistDrawerTrendingPage(trending, normalizedPage, rawPage === 0);

      window.setTimeout(function () {
        data.track.removeAttribute(wishlistDrawerTrendingNormalizingAttribute);
      }, 40);

      return;
    }

    trending.setAttribute(wishlistDrawerTrendingPageAttribute, String(normalizedPage));

    data.dots.forEach(function (dot, index) {
      var isVisibleDot = index < data.pageCount;
      var isActiveDot = index === normalizedPage;

      dot.classList.toggle('wl-trending__dot--active', isActiveDot);
      dot.classList.toggle('is-active', isActiveDot);
      dot.setAttribute('aria-hidden', isVisibleDot ? 'false' : 'true');
      dot.tabIndex = isVisibleDot ? 0 : -1;
    });
  }

  function observeWishlistDrawerTrendingCarousel(trending) {
    var data = getWishlistDrawerTrendingData(trending);
    var observer;

    if (
      !data
      || data.track.getAttribute(wishlistDrawerTrendingObserverAttribute) === 'true'
      || !('MutationObserver' in window)
    ) {
      return;
    }

    data.track.setAttribute(wishlistDrawerTrendingObserverAttribute, 'true');

    observer = new MutationObserver(function () {
      window.requestAnimationFrame(function () {
        normalizeWishlistDrawerTrendingPage(trending);
      });
    });

    observer.observe(data.track, {
      attributes: true,
      attributeFilter: ['style']
    });
  }

  function syncWishlistDrawerTrendingCarousel() {
    document.querySelectorAll(wishlistDrawerTrendingSelector).forEach(function (trending) {
      var data = getWishlistDrawerTrendingData(trending);
      var page;

      if (!data) {
        return;
      }

      page = getWishlistDrawerTrendingPage(trending, data.pageCount);
      setWishlistDrawerTrendingPage(trending, page, false);
      observeWishlistDrawerTrendingCarousel(trending);

      if (trending.getAttribute(wishlistDrawerTrendingBoundAttribute) === 'true') {
        return;
      }

      trending.setAttribute(wishlistDrawerTrendingBoundAttribute, 'true');
      trending.addEventListener(
        'click',
        function (event) {
          var nextButton = event.target.closest('.wl-trending__arrow--next');
          var previousButton = event.target.closest('.wl-trending__arrow--prev');
          var dot = event.target.closest('.wl-trending__dot');
          var currentData;
          var currentPage;
          var dotIndex;

          if (!nextButton && !previousButton && !dot) {
            return;
          }

          currentData = getWishlistDrawerTrendingData(trending);

          if (!currentData) {
            return;
          }

          currentPage = getWishlistDrawerTrendingPage(trending, currentData.pageCount);

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          if (nextButton) {
            setWishlistDrawerTrendingPage(trending, currentPage + 1, true);
            return;
          }

          if (previousButton) {
            setWishlistDrawerTrendingPage(trending, currentPage - 1, true);
            return;
          }

          dotIndex = currentData.dots.indexOf(dot);

          if (dotIndex >= 0 && dotIndex < currentData.pageCount) {
            setWishlistDrawerTrendingPage(trending, dotIndex, true);
          }
        },
        true
      );
    });
  }

  var productModalSwipeState = null;
  var productModalSwipeThreshold = 72;
  var productModalScrollLockClass = 'mystic-product-modal-scroll-locked';
  var productModalScrollLockObserver = null;

  function setProductModalScrollLock(isLocked) {
    document.documentElement.classList.toggle(productModalScrollLockClass, isLocked);
    document.body.classList.toggle(productModalScrollLockClass, isLocked);
  }

  function syncProductModalScrollLock() {
    setProductModalScrollLock(!!document.querySelector('product-modal.is-opened'));
  }

  function initProductModalScrollLock() {
    if (productModalScrollLockObserver) {
      return;
    }

    productModalScrollLockObserver = new MutationObserver(syncProductModalScrollLock);
    productModalScrollLockObserver.observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    syncProductModalScrollLock();
  }

  function isProductModalMobileGestureEnabled() {
    return window.matchMedia && window.matchMedia('(max-width: 1023px)').matches;
  }

  function getOpenProductModal(target) {
    if (!isProductModalMobileGestureEnabled()) {
      return null;
    }

    if (target && target.closest) {
      return target.closest('product-modal.is-opened') || document.querySelector('product-modal.is-opened');
    }

    return document.querySelector('product-modal.is-opened');
  }

  function handleProductModalTouchStart(event) {
    var modal = getOpenProductModal(event.target);
    var touch = event.touches && event.touches[0];

    if (!modal || !touch || event.touches.length !== 1 || modal.hasAttribute('zoom-enabled')) {
      productModalSwipeState = null;
      return;
    }

    if (event.target.closest('modal-button, carousel-button, button, a, video, iframe')) {
      productModalSwipeState = null;
      return;
    }

    productModalSwipeState = {
      modal: modal,
      startX: touch.clientX,
      startY: touch.clientY,
      lastX: touch.clientX,
      lastY: touch.clientY
    };
  }

  function handleProductModalTouchMove(event) {
    var touch = event.touches && event.touches[0];

    if (!productModalSwipeState || !touch) {
      return;
    }

    productModalSwipeState.lastX = touch.clientX;
    productModalSwipeState.lastY = touch.clientY;
  }

  function handleProductModalTouchEnd(event) {
    var state = productModalSwipeState;
    var touch = event.changedTouches && event.changedTouches[0];
    var deltaX;
    var deltaY;

    productModalSwipeState = null;

    if (!state || !state.modal || !state.modal.classList.contains('is-opened')) {
      return;
    }

    deltaX = (touch ? touch.clientX : state.lastX) - state.startX;
    deltaY = (touch ? touch.clientY : state.lastY) - state.startY;

    if (deltaY > productModalSwipeThreshold && deltaY > Math.abs(deltaX) * 1.25) {
      if (typeof state.modal.hide === 'function') {
        state.modal.hide();
      } else {
        state.modal.querySelector('[data-action="close"]')?.click();
      }
    }
  }

  document.addEventListener('touchstart', handleProductModalTouchStart, { passive: true, capture: true });
  document.addEventListener('touchmove', handleProductModalTouchMove, { passive: true, capture: true });
  document.addEventListener('touchend', handleProductModalTouchEnd, { passive: true, capture: true });
  document.addEventListener('touchcancel', function () {
    productModalSwipeState = null;
  }, { passive: true, capture: true });
  initProductModalScrollLock();

  var productModalSelector = 'product-modal';
  var productModalCarouselSelector = '[data-product-modal-carousel]';
  var productModalThumbSelector = '[data-product-modal-thumb-index]';
  var productModalThumbBoundAttribute = 'data-mystic-product-modal-thumbs-bound';
  var productModalEmblaBoundAttribute = 'data-mystic-product-modal-embla-bound';
  var productModalSpeedBoundAttribute = 'data-mystic-product-modal-speed-bound';
  var productModalSlideDuration = 11;

  function updateProductModalThumbs(modal, index) {
    var activeThumb;
    var thumbScroller;

    if (!modal) {
      return;
    }

    modal.querySelectorAll(productModalThumbSelector).forEach(function (thumb) {
      thumb.classList.toggle('is-active', Number(thumb.getAttribute('data-product-modal-thumb-index')) === index);
    });

    activeThumb = modal.querySelector(productModalThumbSelector + '.is-active');
    thumbScroller = activeThumb ? activeThumb.closest('.product-modal__thumbs-scroller') : null;

    if (activeThumb && thumbScroller) {
      thumbScroller.classList.add('mystic-media-thumbnail-indicator-ready');
      updateVariantIndicatorToTarget(thumbScroller, activeThumb, true);
    }
  }

  function bindProductModalThumbClicks(modal) {
    if (!modal || modal.getAttribute(productModalThumbBoundAttribute) === 'true') {
      return;
    }

    modal.setAttribute(productModalThumbBoundAttribute, 'true');
    modal.addEventListener('click', function (event) {
      var thumb = event.target.closest(productModalThumbSelector);
      var carousel;
      var embla;
      var index;

      if (!thumb || !modal.contains(thumb)) {
        return;
      }

      carousel = modal.querySelector(productModalCarouselSelector);
      embla = carousel && carousel.embla;
      index = Number(thumb.getAttribute('data-product-modal-thumb-index'));

      event.preventDefault();

      if (embla && typeof embla.scrollTo === 'function') {
        embla.scrollTo(index);
      }

      updateProductModalThumbs(modal, index);
    });
  }

  function bindProductModalThumbSelect(modal) {
    var carousel = modal && modal.querySelector(productModalCarouselSelector);
    var embla = carousel && carousel.embla;

    if (!carousel || carousel.getAttribute(productModalEmblaBoundAttribute) === 'true') {
      return;
    }

    if (!embla || typeof embla.on !== 'function') {
      window.setTimeout(function () {
        bindProductModalThumbSelect(modal);
      }, 120);
      return;
    }

    carousel.setAttribute(productModalEmblaBoundAttribute, 'true');
    embla.on('select', function () {
      if (typeof embla.selectedScrollSnap === 'function') {
        updateProductModalThumbs(modal, embla.selectedScrollSnap());
      }
    });

    if (typeof embla.selectedScrollSnap === 'function') {
      updateProductModalThumbs(modal, embla.selectedScrollSnap());
    }
  }

  function tuneProductModalCarouselSpeed(modal) {
    var carousel = modal && modal.querySelector(productModalCarouselSelector);
    var embla = carousel && carousel.embla;

    if (!carousel || carousel.getAttribute(productModalSpeedBoundAttribute) === 'true') {
      return;
    }

    if (!embla || typeof embla.reInit !== 'function') {
      window.setTimeout(function () {
        tuneProductModalCarouselSpeed(modal);
      }, 120);
      return;
    }

    carousel.setAttribute(productModalSpeedBoundAttribute, 'true');
    embla.reInit({
      containScroll: false,
      duration: productModalSlideDuration
    });
  }

  function syncProductModalThumbRail() {
    document.querySelectorAll(productModalSelector).forEach(function (modal) {
      bindProductModalThumbClicks(modal);

      if (modal.classList.contains('is-opened')) {
        tuneProductModalCarouselSpeed(modal);
        bindProductModalThumbSelect(modal);
      }
    });
  }

  new MutationObserver(syncProductModalThumbRail).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class']
  });
  syncProductModalThumbRail();

  document.addEventListener('pointerdown', function (event) {
    var trigger = getWishlistPopupDragTrigger(event.target);
    var popup = trigger && trigger.closest('.wl-popup');

    if (!trigger || !popup || !isWishlistPopupSheetView() || event.button > 0) {
      if (trigger) {
        clearWishlistPopupDragState();
      }
      return;
    }

    startWishlistPopupDrag(popup, event.clientX, event.clientY, event.pointerId);
  }, true);

  document.addEventListener('pointermove', function (event) {
    moveWishlistPopupDrag(event.clientX, event.clientY, event.pointerId);
  }, { passive: true });

  document.addEventListener('pointerup', function (event) {
    endWishlistPopupDrag(event.clientX, event.clientY, event.pointerId);
  }, true);

  document.addEventListener('pointercancel', clearWishlistPopupDragState, true);

  document.addEventListener('mousedown', function (event) {
    var trigger = getWishlistPopupDragTrigger(event.target);
    var popup = trigger && trigger.closest('.wl-popup');

    if (!trigger || !popup || !isWishlistPopupSheetView() || event.button > 0) {
      return;
    }

    wishlistPopupMouseActive = true;
    startWishlistPopupDrag(popup, event.clientX, event.clientY, 'mouse');
  }, true);

  document.addEventListener('mousemove', function (event) {
    if (!wishlistPopupMouseActive) {
      return;
    }

    moveWishlistPopupDrag(event.clientX, event.clientY, 'mouse');
  }, true);

  document.addEventListener('mouseup', function (event) {
    if (!wishlistPopupMouseActive) {
      return;
    }

    endWishlistPopupDrag(event.clientX, event.clientY, 'mouse');
  }, true);

  document.addEventListener('touchstart', function (event) {
    var trigger = getWishlistPopupDragTrigger(event.target);
    var popup = trigger && trigger.closest('.wl-popup');
    var touch = event.touches && event.touches[0];

    if (!trigger || !popup || !touch || !isWishlistPopupSheetView()) {
      return;
    }

    startWishlistPopupDrag(popup, touch.clientX, touch.clientY, 'touch');
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', function (event) {
    var touch = event.touches && event.touches[0];

    if (!touch) {
      return;
    }

    moveWishlistPopupDrag(touch.clientX, touch.clientY, 'touch');
  }, { passive: true });

  document.addEventListener('touchend', function (event) {
    var touch = event.changedTouches && event.changedTouches[0];

    if (!touch) {
      clearWishlistPopupDragState();
      return;
    }

    endWishlistPopupDrag(touch.clientX, touch.clientY, 'touch');
  }, true);

  document.addEventListener('click', function (event) {
    var modalBackdrop = document.querySelector('.wl-modal-backdrop');
    var closesModal = event.target && event.target.closest && (
      event.target.closest('.wl-modal__x')
      || event.target.closest('.wl-modal__btn--cancel')
      || event.target.closest('.wl-modal__cancel-btn')
      || event.target.closest('.wl-modal__empty-cancel-btn')
      || event.target === modalBackdrop
    );

    if (!modalBackdrop || !closesModal) {
      return;
    }

    createWishlistModalClosingGhost(modalBackdrop);
  }, true);

  document.addEventListener('click', function (event) {
    var popup = document.querySelector('.wl-popup.wl-popup--open');

    if (!popup || !isWishlistPopupSheetView()) {
      return;
    }

    if (
      event.target.closest('.wl-popup') ||
      event.target.closest('.wl-modal') ||
      event.target.closest('.wl-modal-backdrop') ||
      event.target.closest('.wl-list-modal') ||
      event.target.closest('.wl-list-modal-backdrop') ||
      event.target.closest('.wl-confirm') ||
      event.target.closest('.wl-confirm-backdrop') ||
      event.target.closest('.' + wishlistSelectMenuClass) ||
      event.target.closest('.mystic-wishlist-popup-closing-ghost') ||
      event.target.closest('.mystic-wishlist-remove-confirm') ||
      hasActiveWishlistChildModal()
    ) {
      return;
    }

    createWishlistPopupClosingGhost(popup);
  }, true);

  (function initJudgeMeSearchViewportGuard() {
    var inputSelector = '#judgeme_product_reviews .jm-search-bar__input';
    var viewport = document.querySelector('meta[name="viewport"]');
    var baseContent;
    var restoreTimer;
    var isIosSafariZoomRisk;

    if (!viewport) {
      return;
    }

    isIosSafariZoomRisk = /iP(ad|hone|od)/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (!isIosSafariZoomRisk) {
      return;
    }

    baseContent = viewport.getAttribute('content') || 'width=device-width,initial-scale=1';

    function lockViewportZoom() {
      var current = viewport.getAttribute('content') || baseContent;
      var cleaned = current
        .split(',')
        .map(function (part) {
          return part.trim();
        })
        .filter(function (part) {
          return !/^maximum-scale\s*=/.test(part) && !/^user-scalable\s*=/.test(part);
        })
        .join(',');

      if (restoreTimer) {
        window.clearTimeout(restoreTimer);
        restoreTimer = null;
      }

      viewport.setAttribute('content', cleaned + ',maximum-scale=1');
    }

    function restoreViewportZoom() {
      restoreTimer = window.setTimeout(function () {
        viewport.setAttribute('content', baseContent);
        restoreTimer = null;
      }, 250);
    }

    document.addEventListener('focusin', function (event) {
      if (event.target && event.target.matches && event.target.matches(inputSelector)) {
        lockViewportZoom();
      }
    });

    document.addEventListener('focusout', function (event) {
      if (event.target && event.target.matches && event.target.matches(inputSelector)) {
        restoreViewportZoom();
      }
    });
  })();

})();
